/* eslint-disable import/no-anonymous-default-export */
export default {
  autocomplete: {
    start_typing: `Commencez à écrire...`,
    individual_text: `Écrire une ville ou un état ou un pays`,
    lev_text: `Écrire une ville ou un état ou un pays`,
    no_options: `Aucune option`,
  },
  help_menu: {
    help: `Aide`,
    support: `Support`,
    contact_us: `Contactez-nous`,
    terms: `Conditions`,
    privacy: `Confidentialité`,
    contact_hint: `Incluez tous les détails pertinents et nous vous répondrons.`,
    contact_hint_prefix: `Incluez tous les détails pertinents, ou écrivez-nous directement à`,
    contact_placeholder: `Comment puis-je...`,
    contact_email_subject: `Demande de support Platform`,
    contact_success: `Merci de nous avoir contactés. Un membre de notre équipe vous répondra bientôt.`,
    contact_error: `Impossible d'envoyer votre message. Veuillez réessayer.`,
    send: `Envoyer`,
    sending: `Envoi…`,
    close: `Fermer`,
  },
  featureNotInPlan:
    `Cette fonctionnalité n'est pas disponible dans votre plan.`,
  acknowledgement: `Je reconnais et accepte la politique de Valital`,
  agreement: `J'accepte de`,
  announcement: {
    '2fa': {
      title: `Protégez votre compte avec <br /> l'authentification à deux facteurs`,
      description: `Téléchargez une application d'authentification comme Google Authenticator ou Microsoft Authenticator et l'utiliser pour confirmer votre identité lors de la connexion.`,
      note: `Votre organisation nécessite l'activation de l'authentification à deux facteurs`,
      action_main: `Activer l'authentification à deux facteurs`,
      action_secondary: `Non Merci`,
    },
  },
  agent_chat: {
    title: `Assistant IA`,
    placeholder: `Posez une question…`,
    send: `Envoyer`,
    cancel: `Annuler`,
    retry: `Réessayer`,
    close: `Fermer`,
    new_conversation: `Nouvelle conversation`,
    empty_state: `Posez une question pour commencer.`,
    copy_question: `Copier la question`,
    copy_response: `Copier la réponse`,
    copied: `Copié`,
    copy_failed: `Impossible de copier`,
    status_queued: `Envoi en cours…`,
    status_compacting: `Organisation de la conversation…`,
    status_streaming: `L'assistant répond…`,
    status_reconnecting: `Reconnexion…`,
    status_failed: `Une erreur s'est produite.`,
    status_cancelled: `Réponse annulée.`,
    citations_title: `Sources`,
    citations_has_more: `D'autres sources correspondantes n'ont pas été incluses.`,
    citation_type_validation: `Validation`,
    citation_type_article: `Article`,
    citation_type_event: `Événement`,
    citation_type_product_doc: `Article d'aide`,
    provenance_title: `Contexte des données`,
    provenance_metric_csv_validations_remaining: `Utilisation actuelle du compte`,
    provenance_as_of: `En date du {{value}}`,
    provenance_scope_user: `Utilisateur`,
    provenance_scope_team: `Équipe`,
    provenance_scope_company: `Entreprise`,
    provenance_period_instant: `Actuel`,
    provenance_period_daily: `Quotidien`,
    provenance_period_weekly: `Hebdomadaire`,
    provenance_period_monthly: `Mensuel`,
    day_today: `Aujourd'hui`,
    day_yesterday: `Hier`,
    recent_title: `Conversations récentes`,
    recent_empty: `Aucune conversation récente.`,
    recent_load_more: `Charger plus`,
    recent_retry: `Réessayer`,
    recent_fallback_title: `Nouvelle conversation`,
    recent_open: `Ouvrir les récentes`,
    recent_hide: `Masquer les récentes`,
    session_title_edit: `Renommer la conversation`,
    session_title_save: `Enregistrer`,
    session_title_cancel: `Annuler`,
    session_title_retry: `Réessayer`,
    session_title_empty: `Entrez un titre avant d'enregistrer.`,
    session_title_too_long: `Le titre doit comporter {{max}} caractères ou moins.`,
    session_title_save_failed: `Impossible de renommer la conversation.`,
    report_context_use: `Utiliser le rapport actuel`,
    report_context_current_individual: `Rapport individuel actuel`,
    report_context_current_legal_entity: `Rapport d'entité juridique actuel`,
    report_attach_action: `Joindre des rapports`,
    report_picker_title: `Rapports de référence`,
    report_picker_search: `Rechercher des rapports terminés par nom`,
    report_picker_recent: `Récemment terminés`,
    report_picker_results: `Résultats de recherche`,
    report_picker_empty: `Aucun rapport terminé trouvé.`,
    report_picker_error: `Impossible de charger les rapports.`,
    report_picker_retry: `Réessayer`,
    report_picker_selected: `Joint`,
    report_picker_limit: `Vous pouvez joindre jusqu'à {{max}} rapports de référence.`,
    report_type_individual: `Individu`,
    report_type_legal_entity: `Entité juridique`,
    feedback_helpful: `Utile`,
    feedback_unhelpful: `Pas utile`,
    feedback_comment_label: `Dites-nous en plus (facultatif)`,
    feedback_comment_placeholder: `Qu'est-ce qui a bien fonctionné ou pourrait être amélioré ?`,
    feedback_submit_comment: `Envoyer le commentaire`,
    feedback_skip_comment: `Ignorer`,
    feedback_save_failed: `Impossible d'enregistrer le commentaire`,
    feedback_remove_failed: `Impossible de supprimer le commentaire`,
    delete_session: `Supprimer la conversation`,
    delete_session_confirm_title: `Supprimer cette conversation ?`,
    delete_session_confirm_body:
      `Cette conversation, ses messages et les commentaires associés seront supprimés définitivement et ne pourront pas être récupérés.`,
    delete_session_confirm_action: `Supprimer définitivement`,
    delete_session_cancel: `Annuler`,
    delete_session_active_run_title: `Arrêter la réponse et supprimer la conversation ?`,
    delete_session_active_run_body:
      `Cette conversation a encore une réponse en cours. L'arrêter annulera cette réponse, puis supprimera définitivement la conversation.`,
    delete_session_active_run_action: `Arrêter et supprimer`,
    delete_session_in_progress: `Suppression de la conversation…`,
    delete_session_failed: `Impossible de supprimer la conversation. Veuillez réessayer.`,
    delete_session_timeout:
      `La réponse ne s'est pas arrêtée à temps. La conversation n'a pas été supprimée.`,
    missing_response_reporting: `Signalement du problème…`,
    missing_response_title: `Nous n'avons pas pu générer de réponse.`,
    missing_response_reported_body:
      `Ce problème a été signalé automatiquement à notre équipe. Vous n'avez pas besoin d'envoyer de commentaire.`,
    missing_response_status_reported: `Signalé automatiquement`,
    missing_response_report_failed:
      `Nous n'avons pas pu confirmer que ce problème a été signalé. Vous pouvez réessayer votre question.`,
    missing_response_try_again: `Réessayer`,
  },
  agent_chat_privacy: {
    title: `Assistant IA — avis de confidentialité`,
    storage:
      `Vos questions et les réponses de l'assistant peuvent être enregistrées pour exploiter le service, corriger les problèmes, assurer la sécurité et améliorer la qualité.`,
    internal_access:
      `Seul le personnel Valital autorisé, dans des rôles définis, peut accéder à l'historique des conversations, aux fins ci-dessous. L'accès est limité et audité.`,
    purposes_title: `Finalités`,
    purpose_service: `Fourniture et support de l'assistant`,
    purpose_debugging: `Débogage et gestion des incidents`,
    purpose_safety: `Surveillance de la sécurité (abus, utilisation inappropriée)`,
    purpose_quality: `Amélioration de la qualité de l'expérience`,
    retention:
      `Les transcriptions brutes sont conservées jusqu'à 90 jours, puis supprimées ou anonymisées.`,
    external_llm:
      `Les questions et réponses peuvent être transmises à un fournisseur d'IA externe (comme OpenAI) pour générer des réponses. Nous limitons contractuellement l'utilisation de vos données pour l'entraînement de modèles.`,
    user_rights:
      `Vous pouvez demander l'accès, la rectification ou la suppression en écrivant à privacy@valital.com.`,
    no_training:
      `Nous n'utilisons pas vos conversations pour entraîner des modèles d'IA sans consentement distinct.`,
    learn_more: `Déclaration de confidentialité`,
    view_notice: `Confidentialité`,
    close: `Fermer`,
    privacy_statement_url: `https://www.valital.com/fr/declaration-de-confidentialite`,
    privacy_statement_url_fr: `https://www.valital.com/fr/declaration-de-confidentialite`,
    option_a: {
      checkbox: `J'ai lu et compris comment Valital traite les données de l'assistant IA.`,
      continue: `Continuer vers le clavardage`,
      cancel: `Pas maintenant`,
    },
    option_b: {
      got_it: `Compris`,
      secondary_opt_out_label: `Autoriser l'utilisation de mes questions pour l'amélioration du produit`,
      secondary_opt_out_description:
        `Facultatif. La journalisation liée au service décrite ci-dessus s'applique toujours. Ceci concerne uniquement l'amélioration secondaire.`,
      continue: `Continuer vers le clavardage`,
    },
  },
  lev_not_in_plan: {
    title: `Fonctionnalité non disponible`,
    description_1:
      `Cette fonctionnalité n'est pas disponible dans votre forfait.`,
    description_2: `Veuillez contacter Valital pour l'activer.`,
  },
  back_to_home: `retour à la page principale`,
  continue: `Continuer`,
  loading: `Chargement...`,
  sending: `Envoi en cours...`,
  change_plan_costs_note:
    `<small>Note : l'annulation prématurée de votre plan actuel engendrera des frais de <strong>{{costs}}</strong>.</small>`,
  change_plan_invoice_will_be_sent:
    `Une facture vous sera envoyée dans les prochaines 24 heures.`,
  free_trial: `Vous utilisez l'essai gratuit: {{remaining}} jours restants.`,
  plan_expired: `Votre plan est expiré.`,
  mark_all_as_read: `Cocher le tout comme lu`,
  last_validated: `Dernière mise à jour le {{date}}`,
  live_update_description:
    `LiveUpdate surveillera quotidiennement les medias en ligne et vous informera de toute nouvelle information.`,
  live_update_new_validation_description:
    `Surveillez cette entité de manière quotidienne, hebdomadaire ou mensuelle et soyez alerté de toute nouvelle information.`,
  notify_when_done: `Notifié par email lorsque le rapport est complété.`,
  include_twitter_description: `Activez Twitter pour voir les noms d'utilisateurs potentiels et les tweets signalés associés à cet individu.`,
  extend_report_description:
    `Activez cette fonctionnalité pour inclure les résultats d'inconduite inférieurs à notre seuil de correspondance d'identification. Attendez-vous à plus de faux positifs en conséquence.`,
  not_yet_validated: `Pas encore validé`,
  new_version_available: `Une nouvelle version est disponible`,
  update_now: `Mettez à jour maintenant`,
  detail_view: `Vue de détails`,
  grid_view: `Vue en grille`,
  on_date: `le {{date}}`,
  search_placeholder: `Recherchez par nom`,
  search_min_chars: `Saisissez au moins 3 caractères pour lancer la recherche.`,
  search_no_results: `Aucun résultat.`,
  always_shown: 'toujours affiché',
  column_slot: 'Colonne',
  search_show_all: `Afficher tous les résultats pour {{value}}`,
  something_went_wrong:
    `Oops, quelque chose n'a pas fonctionné ! Veuillez réessayer plus tard`,
  team_validations_depleted:
    `Cette équipe n'a plus de validations disponibles. Contactez votre administrateur pour attribuer davantage de validations pour continuer.`,
  organization_submit_succes: `Votre validation pour {{name}} a été soumise`,
  thank_you_for_your_input: `Merci pour votre contribution`,
  view_all: `visionner le tout`,
  view_all_with_count: `Visionner le tout ({{count}}) →`,
  notifications: {
    a_referral: `une référence`,
    creator_added_subject: `{{creator_name}} a ajouté {{subject_name}}`,
    creator_changed_status:
      `{{creator_name}} a changé le status de {{subject_name}}`,
    from_to: `de "{{previous}}" à "{{next}}"`,
    has_been_validated: `a été validée`,
    has_been_declined: `a été refusé`,
    in_subject_behaviour: `dans les habitudes de {{subject_name}}`,
    on_date: `le {{date}}.`,
    one_of: `L'une des`,
    significant_change_noted: `un changemment important a été noté`,
    subject_added: `{{subject_name}} a ajouté`,
    subject_changed_status:
      `{{subject_name}} a changé le statut du consentement`,
    subject_deleted: `{{subject_name}} a effacé`,
    subject_referrals: `références de {{subject_name}}`,
    subject_removed: `{{subject_name}} a supprimé`,
    subject_updated: `{{subject_name}} mis à jour`,
    their_account: `son compte`,
    to_the_company:
      `à la liste des utilisateurs de l'entreprise de type {{user_type}}`,
    human_curator_updated_report:
      `Le rapport de {{subject_name}} est disponible`,
    refused: `Refusé`,
    accepted: `Accepté`,
    pending: `En attente`,
    load_more: `Voir Plus`,
    active: `Actif`,
    inactive: `Inactif`,
  },
  pages: {
    register: {
      welcome: 'Bienvenue sur Valital, {{firstName}}!',
      welcome_invited: 'Bienvenue chez {{companyName}}, {{firstName}}!',
      complete_registration: 'Complétez votre inscription pour commencer',
      set_password_to_continue: 'Créez votre mot de passe pour accéder à votre compte',
      company_info: 'Informations sur l\'entreprise',
      account_name: 'Nom du compte',
      logo: 'Logo',
      logo_recommended_size: 'Taille recommandée: 512x512px (PNG ou JPG)',
      upload_logo: 'Télécharger le logo de l\'entreprise (optionnel)',
      choose_file: 'Choisir un fichier',
      no_file_chosen: 'Aucun fichier sélectionné',
      email: 'Email',
      password: 'Mot de passe',
      confirm_password: 'Confirmer le mot de passe',
      password_placeholder: 'Créez un mot de passe fort',
      confirm_password_placeholder: 'Ressaisissez votre mot de passe',
      or: 'OU',
      continue_with_google: 'Continuer avec Google',
      continue_with_microsoft: 'Continuer avec Microsoft',
      microsoft_invite_dialog_title: 'Invitation Microsoft requise',
      microsoft_invite_dialog_body:
        'Votre courriel doit être ajouté à votre organisation dans Microsoft Azure avant de pouvoir vous connecter avec Microsoft. Ouvrez le lien d\'invitation, connectez-vous avec votre compte Microsoft et acceptez l\'invitation.',
      microsoft_invite_open_link: 'Ouvrir l\'invitation Microsoft',
      microsoft_invite_after_accept:
        'Lorsque vous avez terminé d\'accepter l\'invitation dans Microsoft, confirmez ci-dessous pour continuer vers la connexion Valital.',
      microsoft_invite_confirm_continue: 'J\'ai accepté — continuer vers la connexion Microsoft',
      microsoft_invite_cancel: 'Pas maintenant',
      microsoft_prepare_unclear:
        'Nous n\'avons pas pu vérifier l\'étape suivante. Terminez l\'invitation Microsoft si nécessaire, puis réessayez.',
      microsoft_prepare_error: 'Impossible de vérifier la configuration Microsoft. Veuillez réessayer.',
      enable_mfa: 'Activer l\'authentification à deux facteurs (2FA)',
      enable_mfa_recommended: 'Activer l\'authentification à deux facteurs (Recommandé)',
      mfa_setup_on_login: 'L\'authentification à deux facteurs sera configurée lors de votre première connexion.',
      sso_info: 'Votre entreprise utilise l\'authentification unique (SSO). Vous pourrez vous connecter en utilisant les identifiants de votre entreprise après avoir complété l\'inscription.',
      sso_complete: 'Cliquez sur "Compléter l\'inscription" ci-dessous. Vous pourrez vous connecter en utilisant SSO sur la page de connexion.',
      login_via_sso: 'Votre entreprise utilise l\'authentification unique (SSO). Veuillez vous connecter en utilisant vos identifiants SSO.',
      sso_google_invited: 'Votre entreprise utilise l\'authentification unique Google (SSO).',
      sso_google_required: 'Votre entreprise exige que vous vous connectiez avec Google.',
      sso_microsoft_invited: 'Votre entreprise utilise l\'authentification unique Microsoft (SSO).',
      signed_in_as: 'Connecté en tant que',
      sso_email_mismatch: 'Ce compte ne correspond pas à votre invitation',
      sso_email_mismatch_help: 'Complétez l\'inscription ci-dessous avec un mot de passe pour votre email invité, ou déconnectez-vous de ce compte et connectez-vous avec le bon.',
      use_different_account: 'Utiliser un autre compte',
      use_different_method: 'Utiliser une autre méthode',
      company_uses_email_password: 'Votre entreprise utilise le courriel et le mot de passe.',
      email_password: 'E-mail et mot de passe',
      sso_invited: 'Votre entreprise utilise l\'authentification unique (SSO).',
      sso_login_instructions: 'Pour accéder à votre compte, veuillez vous rendre sur la page de connexion et vous connecter en utilisant les identifiants SSO de votre entreprise.',
      go_to_login: 'Aller à la page de connexion',
      invalid_email_for_sso: 'Cet email ne correspond pas à l\'email sélectionné.',
      invalid_email_for_microsoft: 'Cet e-mail ne correspond pas à l\'e-mail sélectionné.',
      sso_microsoft_email_mismatch: 'Les adresses email ne correspondent pas. Vous êtes connecté à Microsoft avec une autre adresse. Veuillez vous déconnecter de Microsoft et vous connecter avec le bon compte pour terminer l\'inscription.',
      sso_error_sign_in_required: 'Veuillez vous connecter avec votre compte Google ou Microsoft pour continuer.',
      sso_click_google_first: 'Veuillez d\'abord vous connecter avec Google en cliquant sur le bouton « Continuer avec Google ».',
      sso_click_microsoft_first: 'Veuillez d\'abord vous connecter avec Microsoft en cliquant sur le bouton « Continuer avec Microsoft ».',
      sso_error_sign_in_invalid: 'Votre connexion n\'a pas pu être vérifiée. Veuillez vous reconnecter avec le bon compte.',
      sso_error_email_mismatch: 'Le compte avec lequel vous vous êtes connecté ne correspond pas au courriel de cette inscription. Veuillez vous connecter avec le bon compte.',
      sso_error_provider_mismatch: 'Veuillez utiliser la même option de connexion (Google ou Microsoft) que celle de votre invitation.',
      registration_error_generic: 'Une erreur s\'est produite lors de l\'inscription.',
      accept_and_continue: 'Accepter les conditions et continuer',
      agree_terms: 'J\'accepte les',
      terms_of_use: 'Conditions d\'utilisation de Valital',
      registration_complete: 'Inscription terminée avec succès ! Veuillez vous connecter.',
      registration_error: 'Erreur d\'inscription',
      registration_already_complete_title: 'Votre compte est déjà actif',
      registration_already_complete_body:
        'Ce lien d\'inscription a déjà été utilisé. Connectez-vous pour continuer.',
      activation_link_expired: 'Lien d\'activation expiré',
      request_new_activation_link: 'Demandez-en un nouveau pour activer votre compte.',
      activation_link_resent: 'Un nouveau lien d\'activation a été envoyé à {{email}} et expirera dans 48 heures.',
      back_to_login: 'Retour à la connexion',
      resend_email: 'Renvoyer l\'email',
      intro: {
        title: `Enregistrez-vous<1> gratuitement </1>en 2 étapes simples.`,
        free_trial: `Aucune carte de crédit nécessaire`,
        card_1: `Présentez-nous votre compagnie`,
        card_2: `Parlez-nous de vous`,
      },
      title_step_1: `Parlez-nous de votre compagnie`,
      input_label_step1_1: `Nom de la compagnie `,
      input_label_step1_2: `Nombre d'employés `,
      title_step_2: `Maintenant, parlez-nous de vous`,
      input_label_step2_1: `Courriel professionnel`,
      sign_up: `S'inscrire`,
      success: {
        title: `Votre demande a été soumise`,
        next: `Ensuite: vérifiez votre courriel`,
        description: `
                Nous vous avons envoyé un courriel à <span>{{email}}</span> avec plus d'informations sur les prochaines étapes
                <br/><br/>
                Merci de votre intérêt pour Valital!`,
      },
    },
    activate: {
      almost_there: `encore une étape et votre inscription est terminée`,
      finish_registering:
        `Finalisez votre inscription et commencez à utiliser Valital`,
      stand_out: `Démarquez votre compagnie en ajoutant un logo (optionnel)`,
      complete_registration: `Terminer l'inscription`,
    },
    billing: {
      add_a_card: `Ajoutez une carte`,
      back_to_plans: `Retour aux plans tarifaires`,
      send_invoices_to: `Nous enverrons des factures à ce courriel`,
    },
    business_plans_modal: {
      plans_for_every_org:
        `Peu importe la taille de votre organisation nous avons un plan pour vous.`,
    },
    import_csv_form: {
      title: `Import Individuals`,
      description: `Upload a CSV file to easily add multiple individuals`,
    },
    dashboard: {
      delete_talent: `Effacer le talent`,
      empty_dashboard: {
        title: `Bienvenue sur Valital!`,
        subtitle:
          `Invitez votre premier candidat ou employé et recevez le rapport de son comportement en ligne et de ses références quelques minutes après que l'invitation est acceptée`,
        button_text: `Invitez votre premier talent`,
      },
      cancel: {
        title: `Annuler la demande de consentement ?`,
        body: `En annulant la demande, {{first_name}} {{last_name}} sera supprimé de votre entreprise.`,
      },
      delete: {
        title: `Supprimer {{first_name}}?`,
        body: `Êtes-vous sûr de vouloir supprimer {{first_name}} {{last_name}} de votre entreprise?`,
      },
      live_validation_not_available: {
        title: `Votre plan ne permet pas les alertes liveUpdate`,
        description:
          `Cette fonctionnalité n'est disponible que pour les plans business. Modifiez votre plan pour accéder à la fonctionnalité!`,
      },
      pending_for_more_than_5_days: `En attente depuis plus de 5 jours`,
      columns_to_display: `Colonnes à afficher`,
    },
    delegates: {
      title: `Vos utilisateurs délégués`,
      deactivate: {
        title: `Désactiver {{first_name}} {{last_name}}?`,
        body: `La désactivation d'un utilisateur l'empêchera d'avoir un accès d'utilisateur délégué à cette entreprise.`,
      },
      select_user_type: `Choisir une permission`,
    },
    export_to_csv: `Exporter vers csv`,
    download: `Télécharger`,
    login: {
      '2fa': {
        title: `Entrez le code de sécurité pour continuer`,
        new_device:
          `Nous avons détecté un nouvel appareil, navigateur ou lieu de connexion. Veuillez saisir le code de sécurité reçu par SMS ou généré par votre application d'authentification.`,
        remember_me: `Mémoriser cet appareil pendant {{ days }} jours`,
        issues: `Vous rencontrez des problèmes? Essayez une autre façon`,
        issues_details: `Contactez-nous`,
      },
      title: `Bienvenue à Valital`,
      forgot_password: `Mot de passe oublié ?`,
      start_free_plan: `Commencez gratuitement`,
      invalid_code: `Code invalide. Veuillez réessayer.`,
      account_no_access: `Le compte n'a pas accès`,
      sign_in_with_email_password: `Veuillez vous connecter avec votre adresse courriel et votre mot de passe.`,
      account_not_found: 'Adresse courriel ou mot de passe incorrect. Veuillez réessayer.',
      invalid_email_or_password: 'Adresse e-mail ou mot de passe incorrect. Veuillez réessayer.',
      sign_in_failed: 'Désolé, nous avons des difficultés à vous connecter. Veuillez vérifier vos identifiants ou contacter support@valital.com',
      organization_not_found: `Nous n'avons pas pu trouver de compte correspondant à vos identifiants. Veuillez vérifier votre adresse e-mail et votre méthode d'authentification.`,
      email_not_found: `L'adresse courriel que vous avez saisie est introuvable pour une connexion par défaut. Assurez-vous de la saisir correctement ou d'utiliser la méthode d'authentification correcte.`,
      sso_authentication_required: `Nous n'avons pas pu trouver de compte correspondant à vos identifiants. Veuillez vérifier votre adresse courriel et votre méthode d'authentification.`,
      attemps_excceeded:
        `Tentatives de mot de passe dépassées. Veuillez réessayer dans 2 minutes.`,
      temporary_password_expired: `Votre mot de passe temporaire a expiré.`,
      temp_pass_click_here: `Cliquez ici`,
      temp_pass_reset: `pour le réinitialiser.`,
      temp_pass_sent: `Votre mot de passe temporaire a été envoyé.`,
      mfa_code_resent: `Un nouveau code a été envoyé.`,
      send_magic_link: `Envoyez-moi un lien magique`,
      sending_magic_link: `Envoi en cours...`,
      magic_link_sent: `Un lien magique a été envoyé à votre courriel.`,
      magic_link_error: `Échec de l'envoi du lien magique. Veuillez réessayer.`,
      magic_link_email_required: `Veuillez d'abord entrer votre adresse courriel`,
      magic_link_email_invalid: `Veuillez entrer une adresse courriel valide`,
    },
    profile: {
      '2fa': {
        title: `Entrez votre numéro de cellulaire`,
        subtitle:
          `Gardez votre compte sécurisé avec l'authentification à deux facteurs`,
        description: `L'authentification à deux facteurs ajoute une couche de sécurité supplémentaire en exigeant un code de vérification en plus de votre mot de passe lors de la connexion.`,
        benefit_1: 'Protège contre les accès non autorisés',
        benefit_2: 'Fonctionne avec les applications d\'authentification comme Google Authenticator',
        benefit_3: 'Peut utiliser SMS comme option de secours',
        enabled: `Activée avec le numéro de téléphone {{ phone_number }}`,
        subtitle_admin:
          `Sécurisez encore plus le compte de votre organisation avec l'authentification à deux facteurs`,
        insert_code: `Entrez le code qu'on vous a envoyé par SMS`,
        sending_code: `Envoi du code de vérification... Cela peut prendre quelques instants.`,
        code_expired: `Le code de vérification a expiré. Veuillez demander un nouveau code.`,
        invalid_code: `Code invalide. Veuillez réessayer.`,
        request_new_code: `Demander un nouveau code`,
        change_number: `Changer le numéro`,
      },
      mfa_company_enable_confirm:
        `L'activation de l'authentification à deux facteurs exigera que tous les utilisateurs de votre organisation utilisent l'authentification à deux facteurs. Êtes-vous sûr de vouloir continuer?`,
      mfa_company_disable_confirm:
        `La désactivation de l'authentification à deux facteurs la désactivera pour tous les utilisateurs de votre organisation. Êtes-vous sûr de vouloir continuer?`,
      enable_mfa_warning_title: "Activer l'authentification à deux facteurs",
      enable_mfa_warning_message:
        "L'activation de l'authentification à deux facteurs (2FA) exigera que tous les utilisateurs de votre entreprise activent la 2FA lors de leur prochaine connexion.",
      enable_mfa_warning_alert: '',
      authentication_mode_updated:
        `Mode d'authentification mis à jour avec succès. Les utilisateurs seront migrés automatiquement.`,
      updating_authentication_mode:
        `Mise à jour du mode d'authentification et migration des utilisateurs...`,
      authentication_mode_description:
        `La méthode d'authentification s'applique automatiquement à tous les utilisateurs du compte.`,
      profile_settings_subtitle:
        'Gérez vos informations personnelles et les détails de votre compte',
      profile_basic_information_subtitle:
        'Mettez à jour votre nom',
      security_settings_subtitle:
        'Gérer les paramètres d\'authentification de votre compte',
      live_update_settings_subtitle:
        'Contrôlez la disponibilité, les valeurs par défaut et les notifications par courriel LiveUpdate pour votre compte',
      validation_settings_subtitle:
        'Gérez vos paramètres personnels et ceux du compte pour les validations',
      authentication_mode_change_confirm:
        `Changer la méthode d'authentification s'appliquera à tous les utilisateurs du compte. Ce processus peut prendre quelques instants. Vous serez automatiquement déconnecté après la modification.`,
      authentication_mode_logout_warning:
        `Vous serez automatiquement déconnecté après avoir changé la méthode d'authentification. Veuillez vous reconnecter avec la nouvelle méthode d'authentification.`,
      authentication_mode_owner_stays_signed_in:
        `Le changement de méthode d'authentification s'appliquera à tous les utilisateurs du compte. Vous resterez connecté ; les autres utilisateurs recevront un courriel pour se connecter avec la nouvelle méthode.`,
      authentication_mode_owner_stays_signed_in_point_apply:
        `Le changement de méthode d'authentification s'appliquera à tous les utilisateurs du compte.`,
      authentication_mode_owner_stays_signed_in_point_email:
        `Vous resterez connecté et les autres utilisateurs recevront un courriel pour se connecter avec la nouvelle méthode.`,
      auth_mode_sso_handshake_prompt: `Vérifiez votre courriel.`,
      auth_mode_sso_email_verified: 'Email vérifié.',
      auth_mode_sso_updating: 'Mise à jour...',
      auth_mode_sso_apply: 'Appliquer',
      auth_mode_sso_email_mismatch: `Le compte avec lequel vous vous êtes connecté ne correspond pas à votre courriel. Veuillez vous connecter avec le compte pour {{email}}.`,
      auth_mode_sso_retry_hint: 'Cliquez sur le bouton ci-dessous pour vous connecter à nouveau avec le bon compte.',
      auth_mode_sso_handshake_failed: `La connexion a échoué. Veuillez réessayer.`,
      auth_mode_sso_cancelled: `La connexion a été annulée.`,
      auth_mode_sso_signing_in: `Connexion en cours...`,
      auth_mode_sso_continue_google: `Se connecter avec Google`,
      auth_mode_sso_continue_microsoft: `Se connecter avec Microsoft`,
      auth_mode_sso_popup_blocked: `La fenêtre contextuelle a été bloquée. Veuillez autoriser les fenêtres contextuelles pour ce site et réessayer.`,
      auth_mode_set_password_prompt: 'Définissez votre nouveau mot de passe pour rester connecté.',
      auth_mode_set_password: 'Définissez votre mot de passe.',
      auth_mode_new_password: 'Nouveau mot de passe',
      auth_mode_confirm_password: 'Confirmer le mot de passe',
      auth_mode_password_min_length: 'Le mot de passe doit contenir au moins 8 caractères.',
      auth_mode_password_mismatch: 'Les mots de passe ne correspondent pas.',
      auth_mode_password_requirements: 'Le mot de passe doit respecter toutes les exigences (8+ caractères, majuscule et minuscule, chiffre, caractère spécial).',
      leave_blank:
        `Laissez vide si vous ne désirez pas modifier votre mot de passe`,
      leave_blank_if_no_change:
        `Laissez vide si vous ne prévoyez pas de changer votre mot de passe`,
      enter_current_password: 'Entrez votre mot de passe actuel',
      enter_new_password: 'Entrez un nouveau mot de passe',
      confirm_new_password: 'Confirmez le nouveau mot de passe',
      password_requirements: 'Exigences du mot de passe:',
      password_must_include: 'Votre mot de passe doit inclure :',
      requirement_length: 'Au moins 8 caractères',
      requirement_number: 'Au moins 1 chiffre',
      requirement_uppercase: 'Au moins 1 lettre majuscule',
      requirement_uppercase_az: 'Au moins une lettre majuscule (A-Z)',
      requirement_lowercase_az: 'Au moins une lettre minuscule (a-z)',
      requirement_number_09: 'Au moins un chiffre (0-9)',
      requirement_special_eg: 'Au moins un caractère spécial (p. ex. !, @, #, $)',
      requirement_special: 'Au moins 1 caractère spécial',
      requirement_lowercase: 'Au moins 1 lettre minuscule',
      update_password_description: 'Mettez à jour votre mot de passe pour garder votre compte sécurisé',
      mfa_current_method: 'Méthode actuelle',
      mfa_current_methods: 'Méthodes actuelles',
      mfa_totp_configured_status: 'L\'application d\'authentification est configurée et prête à être utilisée.',
      mfa_using_totp: 'Application d\'authentification',
      mfa_using_sms: 'SMS',
      mfa_phone_number: 'Numéro de téléphone',
      mfa_change_phone: 'Modifier',
      mfa_switch_to_totp: 'Passer à l\'application d\'authentification',
      mfa_switch_to_sms: 'Passer à SMS',
      mfa_use_totp: 'Utiliser l\'application d\'authentification',
      mfa_use_sms: 'Utiliser SMS',
      mfa_setup_totp: 'Configurer l\'application d\'authentification',
      mfa_setup_sms: 'Configurer SMS',
      mfa_setup_required: 'Veuillez configurer au moins une méthode d\'authentification à deux facteurs (2FA). Vous pouvez configurer les deux pour plus de sécurité :',
      mfa_choose_method: 'Choisissez votre méthode d\'authentification à deux facteurs (2FA) préférée avant d\'activer :',
      mfa_totp_configured: '✓ Application d\'authentification',
      mfa_sms_configured: '✓ SMS',
      mfa_configured_methods: 'Méthodes configurées',
      mfa_remove: 'Supprimer',
      mfa_add: 'Ajouter',
      mfa_not_configured: 'Non configuré',
      mfa_remove_confirm_title: 'Supprimer la méthode d\'authentification',
      mfa_remove_sms_confirm: 'Êtes-vous sûr de vouloir supprimer l\'authentification SMS ? Vous aurez toujours l\'application d\'authentification configurée.',
      mfa_remove_totp_confirm: 'Êtes-vous sûr de vouloir supprimer l\'application d\'authentification ? Vous aurez toujours SMS configuré.',
      mfa_remove_error: 'Échec de la suppression de la méthode',
      transfer_ownership_title: 'Transférer la propriété',
      transfer_ownership_info: 'Transférez la propriété de l\'entreprise à un autre administrateur du compte. Vous perdrez l\'accès propriétaire et l\'administrateur du compte sélectionné deviendra le nouveau propriétaire.',
      transfer_ownership_bullet_admins: 'Seuls les administrateurs du compte peuvent être sélectionnés comme nouveau propriétaire',
      transfer_ownership_bullet_irreversible: 'Cette action est irréversible',
      transfer_ownership_admins_label: 'Administrateurs du compte',
      transfer_ownership_select_admin: 'Sélectionner un administrateur du compte',
      transfer_ownership_button: 'Transférer',
      transfer_ownership_confirm_title: 'Confirmer le transfert',
      transfer_ownership_confirm_message: 'Êtes-vous sûr de vouloir transférer la propriété à {{name}} ? Cette action est irréversible.',
      transfer_ownership_confirm_message_no_user: 'Êtes-vous sûr de vouloir transférer la propriété ? Cette action est irréversible.',
      transfer_ownership_success_title: 'Transfert terminé',
      transfer_ownership_success_message: 'La propriété a été transférée avec succès. Vous serez redirigé vers la page d\'accueil.',
      enable_with_totp: 'Activer avec l\'application d\'authentification',
      enable_with_sms: 'Activer avec SMS',
      authentication_mode_subtitle: 'Choisissez comment les utilisateurs s\'authentifient dans votre entreprise',
      sso_contact_required: 'SSO nécessite une configuration spéciale. Veuillez contacter le support pour activer cette fonctionnalité.',
      authentication_mode_contact_support:
        'Pour modifier la méthode d\'authentification, veuillez contacter le support.',
      login_method_contact_support_prefix: 'Si vous souhaitez modifier votre méthode de connexion, veuillez nous contacter à ',
      authentication_mode_contact_support_prefix:
        'Pour modifier la méthode d\'authentification, veuillez contacter ',
      authentication_mode_contact_support_link: 'le support',
      invalid_email_for_sso: 'Cet e-mail ne correspond pas à l\'e-mail sélectionné.',
      invalid_email_for_microsoft: 'Cet e-mail ne correspond pas à l\'e-mail sélectionné.',
      sso_contact_support: 'Contacter le support',
      change_password: 'Changer le mot de passe',
      current_password: 'Mot de passe actuel',
      password_changed: `Le mot de passe a été modifié avec succès`,
      change_password_required: `Changez votre mot de passe`,
      password_set_by_admin: `Votre mot de passe a été défini par un administrateur. Veuillez le changer maintenant pour des raisons de sécurité.`,
      password_change_error: `Échec du changement de mot de passe`,
      delete: {
        delegate: {
          title: `Annulation du compte`,
          body1: `Contactez`,
          body2: `pour procéder à l'annulation de votre compte`,
        },
      },
    },
    referrals: {
      score_1: `L'email de référence n'a pas un domaine de compagnie`,
      score_2:
        `{{company}} est introuvable dans la base de données d'entreprises fédérales canadiennes`,
      score_3:
        `L'email de référence pourrait ne pas appartenir à {{company}}`,
      worked_as: `Rôle `,
      work_period: `Période de travail {{period}}`,
      reference_status: `Statut de la référence{{updated}}`,
      details: `Détails`,
      reference_name: `Nom de la référence`,
      reference_email: `Email de référence`,
      request_reference: {
        text: `Votre talent n'a pas encore partagé de références avec vous.<br/>Demandez une référence en cliquant sur le bouton ci-dessus`,
        button: `Demandez une reference`,
      },
    },
    reset_password: {
      title: `Mot de passe oublié?`,
      title_done: `Merci!`,
      body: `Veuillez entrer votre email pour réinitialiser votre mot de passe`,
      body_done:
        `Le code de réinitialisation du mot de passe a été envoyé. Veuillez vérifier votre boîte de réception.`,
      codes: {
        EMAIL_REQUIRED: 'L\'adresse courriel est requise',
        ACCOUNT_NOT_FOUND: 'Compte introuvable. Veuillez vérifier votre adresse courriel.',
        PASSWORD_RESET_NOT_AVAILABLE: 'La réinitialisation du mot de passe n\'est pas disponible pour ce compte. Veuillez vous connecter avec la méthode de votre entreprise.',
        RESET_EMAIL_SENT: 'Si un compte existe avec cette adresse courriel, vous recevrez un code de vérification sous peu.',
        INTERNAL_ERROR: 'Une erreur s\'est produite. Veuillez réessayer plus tard.',
        RESET_LINK_EXPIRED: 'Ce lien a expiré. Veuillez demander une nouvelle réinitialisation de mot de passe.',
        INVALID_VERIFICATION_CODE: 'Code de vérification invalide. Veuillez réessayer.',
        PASSWORD_RESET_SUCCESS: 'Votre mot de passe a été réinitialisé. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.',
        INVALID_PASSWORD: 'Votre nouveau mot de passe ne respecte pas les exigences.',
      },
    },
    magic_link: {
      verifying: `Vérification de votre lien magique...`,
      title: `Vérification du lien magique`,
      invalid_token: `Lien magique invalide. Aucun code de vérification fourni.`,
      invalid_or_expired: `Ce lien est invalide ou a expiré`,
      expired: `Ce lien magique a expiré.`,
      request_new: `Demander un nouveau lien magique`,
      request_new_link: `Demander un nouveau lien`,
      return_to_login: `Retour à la connexion`,
      back_to_login: `Retour à la connexion`,
    },
    mfa_setup: {
      title: 'Configurer l\'authentification à deux facteurs',
      description: 'Votre entreprise exige l\'authentification à deux facteurs. Choisissez votre méthode préférée:',
      method_totp: 'Application d\'authentification',
      method_totp_description: 'Utilisez une application d\'authentification comme Google Authenticator, Microsoft Authenticator ou Authy.',
      method_sms: 'SMS (Message texte)',
      method_sms_description: 'Nécessite un numéro de téléphone.',
      complete: 'MFA configuré avec succès!',
      complete_description: 'Votre compte est maintenant protégé par l\'authentification à deux facteurs.',
      totp_title: 'Configurer la 2FA avec une application d\'authentification',
      totp_verify_title: 'Entrez le code de vérification',
      totp_description: 'Scannez le code QR dans votre application d\'authentification (Google Authenticator, Microsoft Authenticator, Authy, etc.)',
      totp_scan_instruction: 'Scannez le code QR dans votre application d\'authentification (Google Authenticator, Microsoft Authenticator, Authy, etc.)',
      totp_logo_note: '',
      totp_enter_code: 'Entrez le code à 6 chiffres de votre application d\'authentification',
      totp_success: 'TOTP vérifié avec succès!',
      totp_setup_error: 'Échec de la configuration TOTP',
      totp_verify_error: 'Code de vérification invalide. Veuillez réessayer.',
      totp_switch_title: 'Passer à l\'application d\'authentification',
      totp_switch_description: 'Veuillez vérifier le code de votre application d\'authentification pour passer à cette méthode',
      sms_title: 'Configurer la 2FA avec SMS',
      sms_description: 'Entrez votre numéro de téléphone pour recevoir un code de vérification par message texte',
      sms_enter_phone: 'Entrez votre numéro de téléphone',
      sms_enter_code: 'Entrez le code à 6 chiffres envoyé à votre téléphone',
      sms_success: 'SMS vérifié avec succès!',
      sms_setup_error: 'Échec de l\'envoi du code de vérification',
      sms_verify_error: 'Code de vérification invalide',
      sms_switch_title: 'Configurer SMS',
      sms_switch_description: 'Un code de vérification a été envoyé à votre téléphone. Veuillez vérifier pour passer à l\'authentification SMS.',
      phone_required: 'Le numéro de téléphone est requis',
      invalid_code: 'Veuillez entrer un code à 6 chiffres',
      error_fetching_status: 'Erreur lors de la vérification du statut MFA',
      choose_method_title: 'Authentification à deux facteurs',
      choose_method_description: 'Sélectionnez comment vous souhaitez recevoir votre code de vérification.',
      disable_company_mfa_description: 'En tant qu\'administrateur ou propriétaire, vous pouvez désactiver l\'authentification à deux facteurs pour votre entreprise à la place.',
      disable_company_mfa_button: 'Désactiver l\'authentification à deux facteurs de l\'entreprise',
      mfa_required_message: '',
      use_sms_instead: 'Utiliser SMS à la place',
      use_totp_instead: 'Utiliser l\'application d\'authentification à la place',
    },
    search_results: {
      title: `Tous les résultats pour {{search}}`,
      your_talents: `Vos talents`,
      your_talents_SECURITY: `Individus`,
      not_your_company: `Ne font pas partie de votre entreprise`,
    },
    update_password: {
      body: `Veuillez saisir un nouveau mot de passe pour votre compte`,
      pass_requirements:
        `Doit contenir au moins 1 chiffre, 1 caractère spécial, 1 lettre majuscule, 1 lettre minuscule`,
    },
    sso: {
      body: `Veuillez saisir le domaine de votre organisation`,
    },
    mfa_request: {
      title: `Authentification à deux facteurs`,
      body: `Entrez le code unique que vous avez reçu`,
      not_received: `Vous n'avez pas reçu de code ?`,
      button: `Vérifier`,
    },
    plans: {
      change_plan: `Passer à un plan {{newPlanType}}?`,
      change_plan_final_step:
        `Votre changement sera effectif dès la complétion de cette étape.`,
      no_billing_info:
        `Aucune information de facturation trouvée dans le dossier`,
      no_billing_info_description:
        `Une carte de crédit est requise pour mettre à niveau votre plan`,
      update_billing_info: `Mettre à jour les informations de facturation`,
      invalid_plan: `Plan tarifaire invalide`,
      company_not_registered: `Le plan de votre compagnie a expiré`,
      company_not_registered_details:
        `Veuillez contacter votre administrateur pour vous assurer d'avoir un abonnement actif`,
      unable_to_process_payment:
        `Nous n'avons pas pu traiter le paiement de ce mois`,
      update_billing: `Mettre à jour la facturation`,
      missing_billing_info:
        `Vous n'avez pas de détails de facturations dans le dossier. Ajoutez-les avant votre prochain paiement!`,
    },
    plans_and_payments: {
      view_details: `Voir détails`,
      current_plan: `Plan en cours: {{plan_name}}`,
      billing_cycle_ends: `Renouvellement du plan: {{date}}`,
      next_payment: `Prochain paiement {{next_payment}}`,
      validations_made: `Validations effectuées`,
      validations_remaining: `validations restantes jusqu'au`,
      manage_subscription: `Gérer votre abonnement`,
      your_plan_breakdown: `La ventilation de votre plan pour ce mois:`,
      purchased_bundles: `Bundles ajoutés à ce plan`,
      available_bundles:
        `Vous avez presque atteint la limite de votre plan? Ajouter des validations avec un achat unique.`,
      bundle_types: {
        additional_validations: `validations`,
        additional_users: `utilisateurs`,
      },
      will_be_added:
        `{{count}} {{type}} vont être ajouté(e)s à votre abonnement.`,
      will_be_charged: `Vous serez facturé dès que vous cliquez sur "Acheter"`,
      were_be_added:
        `{{count}} {{type}} ont été ajouté(e)s à votre abonnement.`,
      bundle_unavailable: `Forfait non disponible`,
      bundle_unavailable_free_trial:
        `Vous ne pouvez pas ajouter de bundles avec l'essai gratuit`,
      bundle_unavailable_limit:
        `Vous devez être plus prêt des limites de votre plan pour ajouter un bundle`,
      you_sure_cancel: `Êtes-vous certain de vouloir annuler?`,
      cancel_description_first:
        `Vous allez perdre accès à la plateforme et vous serez chargé`,
      cancel_description_second:
        `selon le nombre de validations utilisées dans votre compte`,
      cancel_successful: `Votre abonnement a été annulé avec succès`,
      questions: `Des questions? Consultez nos`,
      online_conduct_report: `Rapports de conduite en ligne`,
      unlimited_job_confirmation:
        `Confirmations des références d'emploi illimitées`,
      users_per_company: `utilisateurs par compagnie`,
    },
    user_management: {
      teams: {
        type_PRIVATE: `Privé`,
        type_SHARED: `Partagé`,
        team: `Équipe`,
        teams: `Équipes`,
        type: `Type`,
        users: `Utilisateurs`,
        allocated_validations: `Validations attribuées`,
        available_validations: `Validations terminées`,
        remaining_validations: `Validations restantes`,
        validations_available: `{{validations}} validations terminées`,
        add_team: `Ajouter une équipe`,
        edit_team: `Modifier l'équipe`,
        delete_team: `Supprimer l'équipe`,
        delete_step1_body: `La suppression de l'équipe {{team}} déplacera tous les utilisateurs vers l'équipe générale. Les validations restantes seront ajoutées au quota du compte. Vous avez la possibilité de déplacer les validations de cette équipe vers une autre ou de les supprimer définitivement. Tapez "Supprimer l'équipe" pour confirmer la suppression de l'équipe.`,
        delete_button_1: `Supprimer et déplacer les validations`,
        delete_button_2: `Effacé définitivement`,
        delete_button_3: `Retour`,
        delete_button_4: `Supprimer`,
        private_validations: `Validations privées`,
        private_validations_info:
          `Autoriser les membres de l'équipe à soumettre des validations privées qui ne seront pas partagées avec les autres membres de l'équipe`,
        disabled: `Désactivé`,
        enabled: `Activé`,
        min_vals_err:
          `Le nombre de validations doit être supérieur ou égal à 0.`,
      },
      users: {
        user: `Utilisateur`,
        users: `Utilisateurs`,
        access_type: `Type d'accès`,
        status: `Statut`,
        status_ACTIVE: `Actif`,
        status_INACTIVE: `Inactif`,
        status_PENDING: `En attente`,
        add_user: `Ajouter un utilisateur`,
        edit_user: `Modifier l'utilisateur`,
        role_ADMIN: `Administrateur du compte`,
        role_OWNER: `Propriétaire du compte`,
        role_LEAD: `Administrateur de l'équipe`,
        role_MEMBER: `Membre de l'équipe`,
        resend_invitation: `Renvoyer l'invitation`,
        invitation_resent: `Invitation renvoyée à {{email}}`,
        reallocate_validations: `Réattribuer les validations`,
        reallocate_title: `Réattribuer les validations`,
        reallocate_deactivate_title: `Retirer l'accès`,
        reallocate_body:
          `{{name}} a {{count}} validation(s). Choisissez un membre actif qui les reprendra.`,
        reallocate_body_deactivate:
          `{{name}} a {{count}} validation(s). Transférez-les avant de retirer l'accès.`,
        reallocate_target: `Transférer à`,
        reallocate_confirm: `Confirmer`,
        reallocate_and_deactivate: `Transférer et retirer l'accès`,
        reallocate_no_targets: `Aucun membre actif disponible.`,
        reallocate_none: `Aucune validation à réattribuer.`,
        reallocate_success: `Validations transférées`,
        reallocate_and_deactivate_success: `Validations transférées et accès retiré`,
        reallocate_error: `Échec du transfert`,
        reallocate_load_error: `Impossible de charger les validations`,
        reassign_liveupdate_title: `Réattribuer les entités LiveUpdate`,
        reassign_liveupdate_body_one:
          `Cet utilisateur est assigné à 1 entité LiveUpdate. Avant de le rendre inactif, veuillez sélectionner un autre utilisateur actif pour prendre en charge ces entités et recevoir les notifications LiveUpdate par courriel.`,
        reassign_liveupdate_body_other:
          `Cet utilisateur est assigné à {{count}} entités LiveUpdate. Avant de le rendre inactif, veuillez sélectionner un autre utilisateur actif pour prendre en charge ces entités et recevoir les notifications LiveUpdate par courriel.`,
        reassign_liveupdate_assign_to: `Assigner à`,
        reassign_liveupdate_confirm: `Réattribuer et inactiver`,
        reassign_liveupdate_success_one:
          `L'utilisateur a été marqué comme inactif. 1 entité LiveUpdate a été réattribuée à {{name}}, qui recevra les notifications LiveUpdate par courriel.`,
        reassign_liveupdate_success_other:
          `L'utilisateur a été marqué comme inactif. {{count}} entités LiveUpdate ont été réattribuées à {{name}}, qui recevra les notifications LiveUpdate par courriel.`,
      },
    },
    lev_report: {
      summary_details: {
        box_1:
          `Les résultats ci-dessous rapportent des informations en ligne défavorables concernant les facteurs environnementaux, sociaux et de gouvernance, selon les normes et le cadre ESG couramment reconnus.`,
        box_2:
          `Les rapports signalés en jaune mentionnent l'entreprise désignée et contiennent des informations négatives en ligne en lien avec le pilier ESG correspondant.`,
        box_3:
          `Un indicateur vert signifie qu'aucune information en ligne défavorable en lien avec l'ESG n'a été saisie par nos modèles d'IA.`,
        ENVIRONMENT: {
          title: `Environnement`,
          description:
            `Les résultats proviennent des informations publiées en ligne qui mentionnent le nom de l'organisation dans des événements liés à l'environnement. L'indicateur jaune signifie que des comportements défavorables aux critères environmentaux des directives ESG impliquant l'organisation sont signalés.`,
        },
        SOCIAL: {
          title: `Social`,
          description:
            `Les résultats proviennent des informations publiées en ligne qui mentionnent le nom de l'organisation dans des événements liés au volet social. L'indicateur jaune signifie que des comportements défavorables aux critères sociaux des directives ESG impliquant l'organisation sont signalés.`,
        },
        GOVERNANCE: {
          title: `Gouvernance`,
          description:
            `Les résultats proviennent des informations publiées en ligne qui mentionnent le nom de l'organisation dans des événements liés à des sujets de gouvernance. L'indicateur jaune signifie que des comportements défavorables aux critères de gouvernance des directives ESG impliquant l'organisation sont signalés.`,
        },
        OTHER: {
          title: `Autre`,
          description:
            `Les résultats médiatiques défavorables au sujet de l'organisation sont signalés dans cette section lorsqu'ils n'impliquent pas les directives ESG mondialement reconnues.`,
        },
      },
      categories: {
        ENVIRONMENT: `Environnement`,
        FINANCIAL: `Financier`,
        SOCIAL: `Social`,
        GOVERNANCE: `Gouvernance`,
        OTHER: `Autre`,
      },
    },
    report: {
      back_to_top: `Retour en haut`,
      back_to_top_label: `Haut`,
      summary: {
        words: `{{count}} mots`,
        view: `Visualiser le résumé`,
        request: `Résumer l'article`,
        loading: `Chargement...`,
        unavailable: `Le résumé de cet article n'est pas disponible.`,
        error:
          `Impossible d'extraire le résumé de cet article. Veuillez contacter le support si vous avez besoin d'aide.`,
        noCredits: `No more credits!`,
        creditsError:
          `Les {{count}} résumés disponibles ont été utilisé. Veuillez contacter l'administrateur du compte pour faire une demande de résumés additionnels à support@valital.com. `,
        requestMore: `Demander plus`,
      },
      executive_summary: {
        title: `Résumé Exécutif`,
        view_full_executive_summary: `Voir le résumé au complet`,
        show_preview_only: `Afficher l’aperçu seulement`,
        show_more: `Voir plus`,
        show_less: `Voir moins`,
        view_from_list: `Résumé Exécutif`,
        dialog_title: `Résumé Exécutif de {{name}}`,
        validation_last_updated: `Dernière mise à jour de la validation`,
        none_available:
          `Le résumé exécutif n'est pas disponible pour cette validation.`,
        not_generated: `Aucun résumé exécutif n'a été généré.`,
        processing_message:
          `La validation est encore en cours. Le sommaire sera disponible sous peu.`,
      },
      verified_estimate: {
        validation_under_review:
          `Votre validation la plus récente est en progrès d'examen.`,
        ready_shortly: `Le rapport devrait être prêt sous peu...`,
        ready_monday: `Le rapport mis à jour sera disponible lundi à 13 heures. Nous vous informerons par courriel lorsqu'il sera prêt.`,
        ready_in_24: `Le rapport mis à jour sera disponible dans les {{hours}}h. Nous vous informerons par courriel lorsqu'il sera prêt.`,
      },
      history: {
        history: `Historique`,
        no_activities: `Cet utilisateur n'a aucune activité`,
        activities: {
          published_validation: `Rapport a été mis à jour.`,
          toggled_live_update:
            `Alertes LiveUpdate activées par {{user}}.`,
          toggled_live_update_off:
            `Alertes LiveUpdate désactivées par {{user}}.`,
          live_update_enabled: 'Alertes LiveUpdate activées par {{user}}.',
          live_update_enabled_daily:
            'Alertes LiveUpdate quotidiennes activées par {{user}}.',
          live_update_enabled_weekly:
            'Alertes LiveUpdate hebdomadaires activées par {{user}}.',
          live_update_enabled_monthly:
            'Alertes LiveUpdate mensuelles activées par {{user}}.',
          live_update_disabled: 'Alertes LiveUpdate désactivées par {{user}}.',
          added_individual:
            `{{employment}} a été ajouté à votre entreprise par {{user}}`,
          added_talent:
            `{{individual}} a été invité dans votre entreprise par {{user}}`,
          invitation_accepted:
            `{{employment}} a accepté l'invitation de votre entreprise.`,
          invitation_declined:
            `{{employment}} a décliné l'invitation de votre entreprise.`,
          started_validation: `Validation initiée par {{user}}.`,
          preliminary_report: `Rapport préliminaire prêt.`,
          completed_report_ready:
            "Rapport complété prêt. L'Indicateur de Risque est {{riskIndicator}}.",
          validation_updated: 'Validation mise à jour par {{user}}.',
          search_languages_changed:
            'Langues de recherche mises à jour par {{user}} ({{previous}} → {{next}}).',
          live_update_activated: 'Alertes LiveUpdate activées par {{user}}.',
          live_update_deactivated:
            'Alertes LiveUpdate désactivées par {{user}}.',
          risk_indicator_is: "L'Indicateur de Risque est {{riskIndicator}}.", // For standalone risk indicator updates
          validation_reviewed: 'Validation examinée par {{user}}.',
          validation_archived: 'Validation archivée par {{user}}.',
          validation_unarchived: 'Validation désarchivée par {{user}}.',
          validation_report_updated: 'Le rapport a été mis à jour.', // Simplified
          validation_report_complete: 'Le rapport de validation est prêt. L\'indicateur de risque est ',
          new_articles_reported:
            `{{newArticles}} nouveaux articles rapportés par LiveUpdate.`,
          risk_indicator_remains:
            "L'Indicateur de Risque demeure {{riskIndicator}}.",
          risk_indicator_now:
            "L'Indicateur de Risque est maintenant {{riskIndicator}}.",
          // Existing entries follow, adjusted for French grammar where needed
          started_twitter_validation:
            'Une analyse Twitter a été lancée par {{user}}.', // Removed <2> tags as they seem to be for formatting
          from_live_update: 'Nouveaux articles rapportés par LiveUpdate.',
          conduct_changed: "Indicateur de Risque change à ",
          conduct_unchanged: "Indicateur de Risque demeure ",
          lev_conduct_changed: "Indicateur de Risque change à ",
          lev_conduct_unchanged:
            "Indicateur de Risque demeure ",
          sharing_reference_shared:
            `{{employment}} a partagé une référence de {{reference}} avec votre entreprise.`,
          sharing_reference_unshared:
            `{{employment}} a supprimé une référence de {{reference}} avec votre entreprise.`,
          confirming_reference_confirmed:
            `Une référence de {{reference}} a confirmé l'emploi de {{employment}}.`,
          confirming_reference_declined:
            `Une référence de {{reference}} a refusé l'emploi de {{employment}}.`,
          reviewed_by: `Validation examinée par {{name}}.`,
        },
        field_added: '{{field}} ajouté : {{value}}',
        field_removed: '{{field}} supprimé : {{value}}',
        field_changed: '{{field}} modifié : {{previous}} → {{next}}',
        change_actions: {
          added: 'Ajouté',
          changed: 'Modifié',
          removed: 'Supprimé',
        },
        fields: {
          alternative_name: 'Nom alternatif',
          year_of_birth: 'Année de naissance',
          privacy: 'Confidentialité',
          location: 'Emplacement',
          organization_and_roles: 'Organisation et rôle',
          labels: 'Étiquettes',
          search_languages: 'Langues de recherche',
          acronym: 'Acronyme',
          other_name: 'Autre nom',
          industry: 'Industrie',
          live_update_frequency: 'Fréquence LiveUpdate',
        },
      },
      subCategories: {
        ADDICTION: `Dépendance`,
        DISCRIMINATION: `Discrimination`,
        'FINANCIAL CRIME': `Crime Financier`,
        HARASSMENT: `Harcèlement`,
        VIOLENCE: `Violence`,
        NEWS: `Actualités`,
        LITIGATION: `Litige`,
        TWITTERFLAGS: `Tweets Identifiés`,
        ENVIRONMENT: `Environnement`,
        FINANCIAL: `Financier`,
        SOCIAL: `Social`,
        GOVERNANCE: `Gouvernance`,
        OTHER: `Autre`,
        ASSAULT: `Agression`,
        'DOMESTIC VIOLENCE': `Violence Domestique Ou Violence Familiale`,
        RIOT: `Émeute`,
        'SEXUAL VIOLENCE': `Violence Sexuelle`,
        TRAFFICKING: `Contrebande`,
        SLAVERY: `Traite De Personnes`,
        EXTORTION: `Extorsion`,
        'ROBBERY/BURGLARY': `Cambriolage`,
        'SUBSTANCE ABUSE': `Toxicomanie`,
        GAMBLING: `Jeux De Hasard`,
        DUI: `Conduite En État D'ébriété`,
        'ABUSE OF AUTHORITY': `Abus De Pouvoir`,
        'VERBAL AND PSYCHOLOGICAL HARASSMENT':
          `Harcèlement Verbale Et Psychologique`,
        'PHYSICAL AND SEXUAL HARASSMENT': `Harcèlement Physique Et Sexuel`,
        CORRUPTION: `Corruption`,
        'MONEY LAUNDERING': `Blanchiment D'argent`,
        THEFT: `Vol`,
        'TAX EVASION': `Évasion Fiscale`,
        'INSIDER TRADING': `Délit D'initié`,
        'SCAM/HACK': `Arnaque/Piratage`,
        'AGE DISCRIMINATION': `Âgisme`,
        'RELIGIOUS DISCRIMINATION': `Discrimination Religieuse`,
        'RACIAL DISCRIMINATION': `Racisme`,
        'GENDER DISCRIMINATION': `Sexisme`,
        'SEXUAL ORIENTATION DISCRIMINATION':
          `Discrimination Fondée Sur L'orientation Sexuelle`,
        'DISABILITY DISCRIMINATION': `Discrimination En Raison Du Handicap`,
        'PERSONAL CONFLICT': `Conflit Personnel`,
        'COMMERCIAL CONFLICT': `Conflit Commercial`,
        'FALSE ACCUSATION': `Fausse Accusation`,
        'BREACH OF OBLIGATION': `Rupture De Contrat`,
        STRIKE: `Grève`,
        CONTAMINATION: `Contamination`,
        POLLUTION: `Pollution`,
        WASTE: `Déchets`,
        'WASTE EMISSION': `Déchets`,
        EMISSION: `Émission`,
        EXPLOITATION: `Exploitation`,
        'LABOUR UNREST': `Agitation Ouvrière`,
        SHUTDOWN: `Arrêt D'activité`,
        'HUMAN RIGHTS VIOLATION': `Violation Des Droits Humains`,
        LAYOFF: `Licenciement`,
        UNDERPAYING: `Sous-Paiement`,
        'HEALTH & SAFETY VIOLATION': `Violation De Règles De Sécurité/Santé`,
        'CYBER BREACH/CRIME': `Cybercriminalité`,
        ANTITRUST: `Antitrust`,
        SANCTIONS: `Sanctions`,
        'SMUGGLING/TRAFFICKING': `Contrebande`,
        'BREACH OF OBLIGATIONS': `Rupture De Contrat`,
        'FINANCIAL MISCONDUCT': `Inconduite Financière`,
        'BANKRUPTCY/OUT OF BUSINESS': `Faillite/Banqueroute`,
        DELISTING: `Radiation/Décotation`,
        DIVESTURE: `Désaisissement`,
        'STOCK DOWNGRADE': `Déclassement Des Actions`,
        RESTRUCTURING: `Restructuration`,
        LOSSES: `Pertes`,
        'UNDER REPORTING': `Sous-Déclaration`,
        'TERRORIST FINANCING': `Financement De Terrorisme`,
        ABLEISM: `Ableism`,
        FRAUD: `Fraude`,
        VANDALISM: `Validisme`,
        PROSTITUTION: `Prostitution`,
        TERRORISM: `Terrorisme`,
        MURDER: `Meurtre`,
        KIDNAPPING: `Enlèvement`,
        TORTURE: `Torture`,
        ARSON: `Incendie Volontaire/Criminel`,
        GENOCIDE: `Génocide`,
        DEFORESTATION: `Déforestation`,
        DUMPING: `Déversement illégal`,
        NEGLIGENCE: `Négligence`,
        DEFAMATION: `Diffamation`,
        'ANIMAL CRUELTY': `Cruauté Envers Les Animaux`,
        LAYOFFS: `Licenciements`,
        'HEALTH AND SAFETY VIOLATION': `Violation De Règles De Sécurité/Santé`,
        'LABOUR UNREST/SHUTDOWN': `Agitation Ouvrière/Arrêt D'activité`,
        'CYBER CRIME/BREACH': `Cybercriminalité`,
        'FRAUD/THEFT': `Fraude/Vol`,
        'THEFT/FRAUD': `Vol/Fraude`,
        'TRAFFICKING/SLAVERY': `Traite/Esclavage`,
        'TERRORISM/GENOCIDE': `Terrorisme/Génocide`,
        'AGE DISCRIMINATION (AGEISM)': `Âgisme (Âgisme)`,
        'RELIGIOUS/RACIAL DISCRIMINATION': `Discrimination Religieuse/Raciale`,
        'SEXUAL ORIENTIATION DISCRIMINATION': `Discrimination Fondée Sur L'orientation Sexuelle`,
        'DISABILITY DISCRIMINATION (ABLEISM)': `Discrimination En Raison Du Handicap (Validisme)`,
        'BREACH OF OBLIGATION/CONTRACT': `Rupture De Contrat/Obligation`,
      },
      strong_id_match: `Correspondance forte`,
      weak_id_match: `Correspondance possible`,
      potential_false_positive_id_match: `Correspondance faible`,
      id_match_tiers: {
        strong_match: 'Correspondance forte',
        possible_match: 'Correspondance possible',
        weak_match: 'Correspondance faible',
        below_threshold: `Correspondance d'identité`,
      },
      very_weak_id_match: `Identifiant très faible`,
      percentage_id: `{{percentage}}%`,
      more_than_90: `Plus de 90`,
      accused: `Participant`,
      victim: `Référencé`,
      english: `EN`,
      french: `FR`,
      spanish: `ES`,
      portuguese: `PT`,
      arabic: `AR`,
      german: `DE`,
      italian: `IT`,
      russian: `RU`,
      undefined: `Sujet de l'action non analysé`,
      showing_links: `Affichage de {{count}} {{linkWord}}`,
      showing_events_and_links:
        `Affichage de {{eventCount}} {{eventWord}} et {{linkCount}} {{linkWord}}`,
      hidden_by_filters_links: `{{count}} {{linkWord}} masqués par les filtres`,
      hidden_by_filters_events_and_links:
        `{{eventCount}} {{eventWord}} et {{linkCount}} {{linkWord}} masqués par les filtres`,
      showing_results: `Affichage de {{count}} résultat`,
      showing_results_plural: `Affichage de {{count}} résultats`,
      showing_results_events: `Montrant {{count}} évènement`,
      showing_results_plural_events: `Montrant {{count}} évènements`,
      event_singular: `évènement`,
      event_plural: `évènements`,
      link_singular: `lien`,
      link_plural: `liens`,
      showing_results_events_and_links: `Montrant {{eventCount}} {{eventWord}} et {{linkCount}} {{linkWord}}`,
      empty_conduct: {
        title: `Votre rapport est en cours!`,
        description:
          `Rapide est bon; la précision c'est encore mieux. Nous savons ce que vous appréciez le plus.`,
        lev_description:
          `De bons rapports arrivent à ceux qui attendent... juste un peu plus longtemps.`,
      },
      extended_report: {
        notice:
          `Les résultats ci-dessous peuvent inclure des articles inférieurs à notre seuil de correspondance d'identification. Attendez-vous à plus de faux positifs puisque la recherche étendue a été activée.`,
      },
      categories: {
        'HIGH RISK': 'Risque Élevé',
        INVESTIGATE: 'Examiner',
        'WEAK MATCH': 'Non concluant',
        CLEAR: 'Rien à Signaler',
        TWITTER: 'Tweets Signalés',
      },
      languageOptions: {
        english: `Anglais`,
        french: `Français`,
        spanish: `Espagnol`,
        portuguese: `Portugais`,
        arabic: `Arabe`,
        german: `Allemand`,
        italian: `Italien`,
        russian: `Russe`,
      },
      grouping: {
        relevant_links: 'Lien(s) pertinent(s)',
        multi_source_events: "Groupe(s) d’Événements",
        non_grouped_links: 'Événement(s) Non-Groupé(s)',
        events: 'Événements',
      },
      pep: `PPE`,
      soe: `EAE`,
      order: {
        label: `Ordre`,
        changeOrder: `Modifier l'ordre`,
        applyForAllReports: `Définir comme défaut pour tous les rapports`,
        applyForThisReport: `Sauvegarder pour ce rapport`,
        lastSavedAt: `Dernière sauvegarde à {{time}}`,
        status: `Indicateur de Risque`,
        seen_at: `Dernière vue`,
        idm: `Correspondance d'identité`,
        pub_date: `Date de Publication`,
        createdAt: `Date de Validation`,
        reset: `Réinitialiser`,
      },
      review: {
        title: `Examiner le rapport`,
        description:
          "Êtes-vous sûr de vouloir marquer l'ensemble du rapport comme revu ?",
        action: 'Oui',
        error:
          "Une erreur s'est produite lors du marquage du rapport comme revu.",
        reviewed_by: 'Revu le {{date}} par {{user}}',
        validated_by: 'Validé le {{date}} par {{user}}',
        mark_as_reviewed: 'Marquer comme revu',
      },
      hiddenLinks: {
        label: `Liens Masqués`,
        label_singular: `Lien Masqués`,
        confirmDelete:
          `Êtes-vous sûr de vouloir supprimer tous les liens masqués ?`,
        confirmHideTitle: `Masquer le lien`,
        confirmHide: `Êtes-vous sûr de vouloir masquer cet lien ?`,
        confirmShowTitle: `Voir le lien`,
        confirmShow: `Êtes-vous sûr de vouloir afficher cet lien ?`,
        confirm: `Confirmer`,
        cancel: `Annuler`,
        delete: `Supprimer`,
      },
      id_match: {
        promote_to_possible_match: `Changer en correspondance possible`,
        promote_chip_hint: `Confirmer comme correspondance possible`,
        promote_dialog_title: `Changer en correspondance possible ?`,
        promote_dialog_body:
          `Ce lien passera de Non concluant à Examiner. Le pourcentage de correspondance d'identité restera le même.`,
        promote_dialog_confirm: `Changer la correspondance`,
        promote_to_possible_match_success: `Lien changé en correspondance possible`,
        promote_to_possible_match_error: `Impossible de mettre à jour la correspondance du lien`,
      },
      filters: {
        label: `Filtre`,
        category: `Catégorie`,
        applyForAllReports: `Définir comme défaut pour tous les rapports`,
        applyForThisReport: `Sauvegarder pour ce rapport`,
        reset: `Réinitialiser`,
        clear: `Effacer`,
        filter_articles: `Filtrer les articles`,
        topics: `Thèmes`,
        noSubtopic: `Aucun sous-thème n'a été identifié.`,
        general: {
          idMatch: {
            main: `Correspondance d'identité`,
            STRONG: {
              main: `Forte`,
              sentence: `Forte`,
            },
            POSSIBLE: {
              main: `Possible`,
              sentence: `Possible`,
            },
            WEAK_MATCH: {
              main: `Faible`,
              sentence: `Faible`,
            },
            VERY_WEAK: {
              main: `Identifiant très faible`,
              sentence: `Identifiant très faible`,
            },
          },
          language: {
            main: "Langue de l'Article",
            ENGLISH: {
              main: `EN`,
              sentence: `Anglais`,
            },
            FRENCH: {
              main: `FR`,
              sentence: `Français`,
            },
            SPANISH: {
              main: `ES`,
              sentence: `Espagnol`,
            },
            PORTUGUESE: {
              main: `PT`,
              sentence: `Portugais`,
            },
            ARABIC: {
              main: `AR`,
              sentence: `Arabe`,
            },
            GERMAN: {
              main: `DE`,
              sentence: `Allemand`,
            },
            ITALIAN: {
              main: `IT`,
              sentence: `Italien`,
            },
            RUSSIAN: {
              main: `RU`,
              sentence: `Russe`,
            },
          },
          sourceCategory: {
            main: "Source d'Information",
            mainstream_media: {
              sentence: `Médias traditionnels`,
            },
            government_agencies: {
              sentence: `Organismes gouvernementaux`,
            },
            legitimate_online_database: {
              sentence: `Bases de données légitimes`,
            },
            education_professional_associations: {
              sentence: `Institutions reconnues`,
            },
            strong_content: {
              sentence: `Qualité de contenu élevée`,
            },
            user_source: {
              sentence: `Mes Sources`,
            },
            not_verified: {
              sentence: `Non Vérifiée`,
            },
          },
          articleType: {
            main: `Type d'article`,
            LIVE: {
              main: `En Continu`,
              sentence: `Articles en continu`,
            },
            INSTANT: {
              main: `Instant`,
              sentence: `Articles instants`,
            },
          },
          source: {
            main: `Source`,
            CREDIBLE: {
              main: `Vérifiée`,
              sentence: `Source vérifiée`,
            },
            NOT_CREDIBLE: {
              main: `Non-Vérifiée`,
              sentence: `Source non-Vérifiée`,
            },
          },
          riskIndicator: {
            main: 'Indicateur de Risque',
            'HIGH RISK': { sentence: 'Risque Élevé' },
            INVESTIGATE: { sentence: 'Examiner' },
            CLEAR: { sentence: 'Rien à Signaler' },
            'WEAK MATCH': { sentence: 'Non concluant' },
          },
          hasPep: {
            true: { sentence: `PPE` },
          },
          hasSOE: {
            true: { sentence: `EAE` },
          },
          topic: {
            main: `Thèmes`,
            LITIGATION: { sentence: `Litige` },
            VIOLENCE: { sentence: `Violence` },
            HARASSMENT: { sentence: `Harcèlement` },
            ADDICTION: { sentence: `Dépendance` },
            NEWS: { sentence: `Actualités` },
            FINANCIAL: { sentence: `Financier` },
            'FINANCIAL CRIME': { sentence: `Crime Financier` },
            DISCRIMINATION: { sentence: `Discrimination` },
            ENVIRONMENT: { sentence: `Environnement` },
            SOCIAL: { sentence: `Social` },
            GOVERNANCE: { sentence: `Gouvernance` },
            OTHER: { sentence: `Autre` },
          },
          main: `Sous-Thèmes`,
          subTopic: {
            main: `Sous-Thèmes`,
            ASSAULT: { sentence: `Agression` },
            'DOMESTIC VIOLENCE': {
              sentence: `Violence Domestique Ou Familiale`,
            },
            RIOT: { sentence: `Émeute` },
            'SEXUAL VIOLENCE': { sentence: `Violence Sexuelle` },
            TRAFFICKING: { sentence: `Contrebande` },
            SLAVERY: { sentence: `Traite De Personnes` },
            EXTORTION: { sentence: `Extorsion` },
            'ROBBERY/BURGLARY': { sentence: `Cambriolage` },
            'SUBSTANCE ABUSE': { sentence: `Toxicomanie` },
            GAMBLING: { sentence: `Jeux De Hasard` },
            DUI: { sentence: `Conduite En État D'ébriété` },
            HARASSMENT: { sentence: `Harcèlement` },
            'ABUSE OF AUTHORITY': { sentence: `Abus De Pouvoir` },
            'VERBAL AND PSYCHOLOGICAL HARASSMENT': {
              sentence: `Harcèlement Verbale Et Psychologique`,
            },
            'PHYSICAL AND SEXUAL HARASSMENT': {
              sentence: `Harcèlement Physique Et Sexuel`,
            },
            CORRUPTION: { sentence: `Corruption` },
            'MONEY LAUNDERING': { sentence: `Blanchiment D'argent` },
            THEFT: { sentence: `Vol` },
            'TAX EVASION': { sentence: `Évasion Fiscale` },
            'INSIDER TRADING': { sentence: `Délit D'initié` },
            'SCAM/HACK': { sentence: `Arnaque/Piratage` },
            'AGE DISCRIMINATION': { sentence: `Âgisme` },
            'RELIGIOUS DISCRIMINATION': {
              sentence: `Discrimination Religieuse`,
            },
            'RACIAL DISCRIMINATION': { sentence: `Racisme` },
            'GENDER DISCRIMINATION': { sentence: `Sexisme` },
            'SEXUAL ORIENTATION DISCRIMINATION': {
              sentence: `Discrimination Fondée Sur L'orientation Sexuelle`,
            },
            'DISABILITY DISCRIMINATION': {
              sentence: `Discrimination En Raison Du Handicap`,
            },
            'PERSONAL CONFLICT': { sentence: `Conflit Personnel` },
            'COMMERCIAL CONFLICT': { sentence: `Conflit Commercial` },
            'FALSE ACCUSATION': { sentence: `Fausse Accusation` },
            'BREACH OF OBLIGATION': { sentence: `Rupture De Contrat` },
            STRIKE: { sentence: `Grève` },
            CONTAMINATION: { sentence: `Contamination` },
            POLLUTION: { sentence: `Pollution` },
            WASTE: { sentence: `Déchets` },
            'WASTE EMISSION': { sentence: `Déchets` },
            EMISSION: { sentence: `Émission` },
            DISCRIMINATION: { sentence: `Discrimination` },
            EXPLOITATION: { sentence: `Exploitation` },
            'LABOUR UNREST': { sentence: `Agitation Ouvrière` },
            SHUTDOWN: { sentence: `Arrêt D'activité` },
            'HUMAN RIGHTS VIOLATION': {
              sentence: `Violation Des Droits Humains`,
            },
            LAYOFF: { sentence: `Licenciement` },
            UNDERPAYING: { sentence: `Sous-Paiement` },
            'HEALTH & SAFETY VIOLATION': {
              sentence: `Violation De Règles De Sécurité/Santé`,
            },
            'CYBER BREACH/CRIME': { sentence: `Cybercriminalité` },
            ANTITRUST: { sentence: `Antitrust` },
            LITIGATION: { sentence: `Litige` },
            SANCTIONS: { sentence: `Sanctions` },
            'SMUGGLING/TRAFFICKING': { sentence: `Contrebande` },
            'BREACH OF OBLIGATIONS': { sentence: `Rupture De Contrat` },
            'FINANCIAL MISCONDUCT': { sentence: `Inconduite Financière` },
            'BANKRUPTCY/OUT OF BUSINESS': { sentence: `Faillite/Banqueroute` },
            DELISTING: { sentence: `Radiation/Décotation` },
            DIVESTURE: { sentence: `Désaisissement` },
            'STOCK DOWNGRADE': { sentence: `Déclassement Des Actions` },
            RESTRUCTURING: { sentence: `Restructuration` },
            LOSSES: { sentence: `Pertes` },
            'UNDER REPORTING': { sentence: `Sous-Déclaration` },
            'TERRORIST FINANCING': { sentence: `Financement De Terrorisme` },
            ABLEISM: { sentence: `Ableism` },
            FRAUD: { sentence: `Fraude` },
            VANDALISM: { sentence: `Validisme` },
            PROSTITUTION: { sentence: `Prostitution` },
            TERRORISM: { sentence: `Terrorisme` },
            MURDER: { sentence: `Meurtre` },
            KIDNAPPING: { sentence: `Enlèvement` },
            TORTURE: { sentence: `Torture` },
            ARSON: { sentence: `Incendie Volontaire/Criminel` },
            GENOCIDE: { sentence: `Génocide` },
            DEFORESTATION: { sentence: `Déforestation` },
            DUMPING: { sentence: `Déversement illégal` },
            NEGLIGENCE: { sentence: `Négligence` },
            DEFAMATION: { sentence: `Diffamation` },
            'ANIMAL CRUELTY': { sentence: `Cruauté Envers Les Animaux` },
            LAYOFFS: { sentence: `Licenciements` },
            'HEALTH AND SAFETY VIOLATION': { sentence: `Violation De Règles De Sécurité/Santé` },
            'LABOUR UNREST/SHUTDOWN': { sentence: `Agitation Ouvrière/Arrêt D'activité` },
            'CYBER CRIME/BREACH': { sentence: `Cybercriminalité` },
            'FRAUD/THEFT': { sentence: `Fraude/Vol` },
            'THEFT/FRAUD': { sentence: `Vol/Fraude` },
            'TRAFFICKING/SLAVERY': { sentence: `Traite/Esclavage` },
            'TERRORISM/GENOCIDE': { sentence: `Terrorisme/Génocide` },
            'AGE DISCRIMINATION (AGEISM)': { sentence: `Âgisme (Âgisme)` },
            'RELIGIOUS/RACIAL DISCRIMINATION': { sentence: `Discrimination Religieuse/Raciale` },
            'SEXUAL ORIENTIATION DISCRIMINATION': { sentence: `Discrimination Fondée Sur L'orientation Sexuelle` },
            'DISABILITY DISCRIMINATION (ABLEISM)': { sentence: `Discrimination En Raison Du Handicap (Validisme)` },
            'BREACH OF OBLIGATION/CONTRACT': { sentence: `Rupture De Contrat/Obligation` },
          },
          events: {
            main: `D'événements`,
            multi_source_events: `Groupe(s)`,
            non_grouped_links: `Non-Groupé(s)`,
            relevant_links: { sentence: `Lien(s) Pertinent(s)` },
          },
          publishDate: {
            main: 'Date de Publication',
            include: 'Inclure les articles sans date de publication',
            selectPresetRange: 'Sélectionnez',
            by: 'Par ',
            from: 'de',
            to: 'à',
            fromStart: 'De {{start}}',
            toEnd: "Jusqu'à {{end}}",
            range: 'Publié entre {{start}} et {{end}}',
            startDate: 'Publié depuis {{start}}',
            endtDate: 'Publié avant {{end}}',
            noDate: 'Sans Date de Publication',
            thisMonth: 'Ce mois-ci',
            custom: 'Personaliser',
            yesterday: 'Depuis hier',
            lastYear: '12 derniers mois',
            last6Months: '6 derniers mois',
            last3Months: '3 ans derniers',
            last2Years: '2 ans derniers',
            last5Years: '5 ans derniers',
            clear: 'Effacer',
            apply: 'Appliquer',
          },
          validationDate: {
            main: 'Date de Validation',
            selectPresetRange: 'Sélectionner',
            range: 'Date de {{start}}, Date de {{end}}',
            by: 'Par',
            from: 'de ',
            to: 'à',
            fromStart: 'Depuis {{start}}',
            toEnd: "Jusqu'à {{end}}",
            startDate: 'Validé depuis {{start}}',
            endDate: "Validé jusqu'à {{end}}",
            yesterday: 'Depuis hier',
            custom: 'Personnalisé',
            thisMonth: 'Ce mois-ci',
            lastYear: 'Les 12 derniers mois',
            last6Months: 'Les 6 derniers mois',
            last3Months: 'Les 3 derniers mois',
            last2Years: 'Les 2 dernières années',
            last5Years: 'Les 5 dernières années',
            clear: 'Effacer',
            apply: 'Appliquer',
          },
          subject: {
            main: `Rôle`,
            direct_participant: {
              main: `Participant Direct`,
              sentence: `Participant Direct`,
            },
            involved: {
              main: `Impliqué`,
              sentence: `Impliqué`,
            },
            referenced: {
              main: `Référencé`,
              sentence: `Référencé`,
            },
          },
          extendReport: {
            main: `Rapport d'étendue`,
            TRUE: {
              main: `Oui`,
              sentence: `Est un rapport étendu`,
            },
            FALSE: {
              main: `Non`,
              sentence: `N'est pas un rapport étendu`,
            },
          },
        },
        validations: {
          show_archived_only: `Afficher les validations archivées`,
          show_not_archived_only: `Afficher les validations actives`,
          show_all: `Afficher toutes les validations`,
          privacy: `Partagée`,
          show_private: `Validations privées`,
          show_public: `Validations partagées`,
          team: `Équipe`,
          live_update_filter_any: `Afficher tout`,
          live_update_filter_on: `Activé`,
          live_update_filter_off: `Désactivé`,
          live_update_filter_frequency: `Fréquence (si activé)`,
        },
      },
      theme: {
        main: `Inconduite`,
        ADDICTION: `Dépendance`,
        DISCRIMINATION: `Discrimination`,
        'FINANCIAL CRIME': `Crime Financier`,
        HARASSMENT: `Harcèlement`,
        VIOLENCE: `Violence`,
        NEWS: `Actualités`,
        LITIGATION: `Litige`,
        TWITTERFLAGS: `Tweets identifiés`,
      },
      lev_theme: {
        ENVIRONMENT: `Environnement`,
        FINANCIAL: `Financier`,
        SOCIAL: `Social`,
        GOVERNANCE: `Gouvernance`,
        OTHER: `Autre`,
      },
      conduct_summary: {
        title: `Signaler`,
        identity_weak_match_card: `Correspondance faible`,
        weak_match_card: `Non concluant`,
        inconclusive_card: `Non concluant`,
        beta_label: `Bêta`,
        new_count_label_one: `{{formattedCount}} Nouveau`,
        new_count_label_other: `{{formattedCount}} Nouveaux`,
        new_word_one: `Nouveau`,
        new_word_other: `Nouveaux`,
        how_to_read_this_report: `Comment lire ce rapport`,
        no_articles_found: `Aucun article de {{misconduct}} trouvé`,
        articles_analyzed:
          ` Liens Pertinents rapportés parmi plus de {{found}} analysés`,
      },
      twitter: {
        flagged_on: `Signalé le`,
        title:
          `Activité signalés pour inconduite pour <2>@{{twitter_screen_name}}</2>`,
        tweets_flagged:
          `{{flagged}} tweets sur {{analyzed}} signalés dans la dernière analyse`,
        tweets_flagged_date:
          `{{flagged}} tweets sur {{analyzed}} signalés dans la dernière analyse ({{start}} - {{end}})`,
        no_twitter_account: {
          title:
            `Nous n'avons pas de nom d'utilisateur Twitter associé à cette personne.`,
          subtitle:
            `Associez un compte Twitter ci-dessous ou mettez à jour la validation de l'individu.`,
          button: `Lancer une analyse Twitter`,
        },
        no_tweets: {
          title:
            `Nous n'avons trouvé aucun tweets à analyser sur <2>@{{twitter_screen_name}}</2>`,
          subtitle:
            `Cela peut être dû au fait que le compte est privé ou que le nom d'utilisateur n'existe pas.`,
        },
        all_good: {
          title:
            `Nous avons analysé {{analyzed}} tweets et aucun tweet n'est à signaler pour @{{twitter_screen_name}}`,
          zero_retrieved:
            `Nous avons trouvé 0 {{tweetsOrRetweets}} pour @{{twitter_screen_name}}`,
        },
      },
      summary_details: {
        clear_title: `Rien à Signaler`,
        clear_description: `Les articles font`,
        Reference_description: 'Référence ',
        clear_description_ind: `à l'individu, mais celui-ci n'est ni un Participant Direct ni Impliqué dans une inconduite.`,
        clear_description_lev: `à l'organisation, mais celle-ci n'est ni un Participant Direct ni Impliquée dans une nouvelle négative.`,  
        green_description_lev1: `Des articles contenant des nouvelles en ligne négatives au sujet de l'individu ont été détectés. Cependant, l'organisation n'en serait un participante`,
        OR: `OU`,
        green_description_lev3: `les articles détectés en ligne au sujet de l'organisation ne contiennent pas des sujets d'inconduite.`,
        investigate_title: `Examiner`,
        investigate_description_ind1: `Toutefois, la correspondance avec votre sujet peut être incertaine ou partielle, ou la source peut être non vérifiée. Alternativement, les articles présentent l’individu comme étant`,
        investigate_description_ind3: `dans une inconduite, à condition que la correspondance d'identité soit classée comme Forte ou Possible.`,
        investigate_description_lev1:`Toutefois, la correspondance avec votre sujet peut être incertaine ou partielle, ou la source peut être non vérifiée. Alternativement, les articles présentent l’organisation comme étant`,
        investigate_description_lev3: `dans une inconduite, à condition que la correspondance d'identité soit classée comme Forte ou Possible.`,     
        high_risk_title: `Risque Élevé`,
        articles_rerfer_individual: `Les articles font référence à la personne en tant que`,
        articles_rerfer_lev: `Les articles font référence à l’organisation en tant que`,
        direct_participant: `Participant Direct`, 
        involved_description: 'Impliquée',
        involved_description_ind: 'impliqué',
        involved_description_lev: 'impliquée',
        high_risk_description_bold: `Participant Direct`,
        high_risk_description: `à une inconduite. Le lien semble correspondre fortement à votre sujet et la source est vérifiée.`,       
        high_risk_description_lev: `à une nouvelle en ligne négative. Le lien semble correspondre fortement à votre sujet et la source est vérifiée.`, 
        twitter_title: `Tweets Signalés`,
        twitter_description: `Les tweets et retweets sont signalés si le contenu et le contexte appartiennent aux cinq catégories d'inconduites. L'utilisation d'un langage grossier ou inapproprié est également signalée.`,
        relevant_links: `Liens Pertinents`,
        relevant_links_description: `Liens rapportés avec une corrélation de l'identifiant de 60% ou plus. Le résultat de l'analyse de ces liens fait partie d'une des catégories: Risque élevé, Examiner, Rien à signaler ou Non concluant.`,
        relevant_links_lev_description: `Liens rapportés avec une corrélation de l'identifiant de 60% ou plus. Le résultat de l'analyse de ces liens fait partie d'une des catégories: Risque élevé, Examiner, Rien à signaler ou Non concluant.`,
        executive_summary_how_to_read_title: `Résumé exécutif`,
        executive_summary_how_to_read_description: `Un aperçu structuré des résultats, se concentrant sur les correspondances d'identité Fortes et Possibles, avec les événements clés présentés par ordre chronologique pour soutenir une évaluation efficace des risques.`,
        identity_weak_match_title: `Correspondance faible`,
        identity_weak_match_description:
          `La correspondance faible regroupe les liens pour lesquels nos vérifications suggèrent un lien plus tenu avec votre sujet qu’une correspondance forte ou possible. Ils ne sont pas ajoutés aux totaux Risque élevé, Examiner ou Rien à signaler ; utilisez la carte grise Correspondance faible pour les consulter ou les filtrer.`,
        weak_match_title: `Non concluant`,
        weak_match_how_to_read_description_iv:
          `Résultats identifiés avec des correspondances d'identité Faibles, où les informations disponibles sont insuffisantes pour établir une association claire avec l'entité. Ces conclusions ne contribuent pas à l'évaluation globale du risque, à l'identification des PPE ou à la création des événements.`,
        weak_match_how_to_read_description_lev:
          `Résultats identifiés avec des correspondances d'identité Faibles, où les informations disponibles sont insuffisantes pour établir une association claire avec l'entité. Ces conclusions ne contribuent pas à l'évaluation globale du risque, à l'identification des EAE ou à la création des événements.`,
        events: 'Événements',
        events_description: `Un événement défavorable identifié à partir d'une ou plusieurs sources.`, 
        pep: `PPE`,
        pep_description: `Articles signalés en temps réel à partir de sources mondiales, identifiant un individu comme une Personne Politiquement Exposée. (PPE)`,
        soe: `EAE`,
        soe_description: `Une Entreprise Appartenant à l’État (EAE), partiellement ou totalement, identifiée à l'aide de renseignements en sources ouvertes et d'une analyse par intelligence artificielle générative.`,
        total_articles_event: `Événement contient : {{articles}} liens.`,
        show_link: `Voir le lien`,
        single_source: `Source unique`,
        view_less: `Voir moins`,
        view_all: `Voir tous`,
      },
      articles_found: {
        title: `Liens Rapportés`,
        empty_title: `Tout est en ordre!`,
        empty_description:
          `  Nous n'avons pas trouvé des articles pour cette section`,
        source_is_credible: `Crédibilité de la source validée`,
      },
      profile: {
        year_of_birth: `Année de naissance`,
      },
      load_more: `Charger plus`,
      article_roles: {
        direct_participant: `Participant Direct`,
        involved: `Impliqué`,
        referenced : `Référencé`
      },
    },
    lev_csv_form: {
      validate_from_csv: `Valider à partir d'un fichier CSV`,
      heading: `Votre fichier CSV doit contenir les colonnes suivantes:`,
      subheading:
        `Vous pouvez réviser et modifier chaque ligne avant de soumettre.`,
      download_template: `Télécharger le modèle`,
      download_example: `Télécharger l'exemple`,
      downloaded_template: `Valital-Organisation-CSV-Modele.csv`,
      downloaded_example: `Valital-Organisation-CSV-Exemple.csv`,
      upload_file: `Téléverser le fichier`,
      upload_or_drop: `Téléverser ou déposer un CSV`,
      blank_template_title: `Modèle vierge`,
      blank_template_description: `En-têtes de colonnes uniquement, prêt à remplir.`,
      example_file_title: `Fichier d'exemple`,
      example_file_description: `Mêmes en-têtes avec des lignes d'exemple remplies.`,
      sample_preview_label: `Format d'exemple`,
      sample_col_name: `Organisation`,
      sample_col_industry: `Industrie`,
      sample_col_location: `Localisation (optionnel)`,
      sample_col_lu: `Fréquence LU`,
      sample_col_languages: `Langues`,
      sample_empty: `(vide)`,
      start_from_file: `Commencer à partir d'un fichier`,
      required_fields_hint:
        `Téléchargez l'un de ces fichiers, remplissez vos organisations, puis téléversez-le ci-dessous. Seuls le <bold>Nom de l'organisation</bold> et l'<bold>Industrie</bold> sont obligatoires.`,
      defaults_hint:
        `La ville, la province et le pays sont optionnels. Laissez la fréquence LiveUpdate ou les langues de recherche vides et nous appliquerons vos paramètres par défaut automatiquement.`,
      fix_errors: `Vous devez corriger les erreurs avant de soumettre.`,
      bullets: {
        organization_name: `Nom de l'organisation`,
        acronym: `Acronyme (optionnel)`,
        other_name: `Autre Nom (optionnel)`,
        city: `Ville de résidence (optionnel)`,
        province: `Province / État (optionnel)`,
        country: `Pays (optionnel)`,
        industry: `Industrie`,
        live_update_frequency:
          'Fréquence LiveUpdate (quotidien, hebdomadaire, mensuel ; off ou vide pour désactiver)',
        search_languages:
          `Langues de recherche (optionnel — en, fr, es, pt, ar, de, it, ru ; séparées par des virgules ; max. 4)`,
      },
      error: {
        invalid_file_type: `Veuillez téléverser un fichier CSV (.csv)`,
        name_missing: `Nom de l'organisation manquant`,
        search_languages_invalid:
          `Langues de recherche invalides (utilisez en, fr, es, pt, ar, de, it, ru — max. 4, séparées par des virgules)`,
        industry_missing: `Industrie manquante`,
        industry_max_length: `L'industrie ne doit pas dépasser {{max}} caractères.`,
      },
    },
    csv_form: {
      import_csv: `Importer un fichier CSV`,
      validate_from_csv: `Valider à partir d'un fichier CSV`,
      heading: `Votre fichier CSV doit contenir les colonnes suivantes:`,
      subheading:
        `Vous pouvez réviser et modifier chaque ligne avant de soumettre.`,
      download_template: `Télécharger le modèle`,
      download_example: `Télécharger l'exemple`,
      downloaded_template: `Valital-Individu-CSV-Modele.csv`,
      downloaded_example: `Valital-Individu-CSV-Exemple.csv`,
      upload_file: `Téléverser le fichier`,
      upload_or_drop: `Téléverser ou déposer un CSV`,
      blank_template_title: `Modèle vierge`,
      blank_template_description: `En-têtes de colonnes uniquement, prêt à remplir.`,
      example_file_title: `Fichier exemple`,
      example_file_description: `En-têtes et 3 lignes exemple.`,
      sample_preview_label: `Format exemple`,
      sample_col_first_name: `Prénom`,
      sample_col_last_name: `Nom de famille`,
      sample_col_country: `Pays`,
      sample_col_lu: `Fréq. LiveUpdate`,
      sample_col_languages: `Langues`,
      sample_empty: `(vide)`,
      start_from_file: `Commencer à partir d'un fichier`,
      required_fields_hint:
        `Téléchargez l'un de ces fichiers, remplissez vos individus, puis téléversez-le ci-dessous. Seuls le <bold>Prénom</bold>, le <bold>Nom de famille</bold> et le <bold>Pays</bold> sont obligatoires.`,
      defaults_hint:
        `Laissez Fréquence LiveUpdate ou Langues de recherche vides et nous appliquerons vos paramètres par défaut automatiquement.`,
      fix_errors: `Vous devez corriger les erreurs avant de soumettre.`,
      error: {
        invalid_file_type: `Veuillez téléverser un fichier CSV (.csv)`,
        first_name_missing: `Prénom manquant`,
        last_name_missing: `Nom de famille manquant`,
        last_name_invalid: `Nom de famille invalide`,
        first_name_invalid: `Prénom invalide`,
        city_invalid: `Ville invalide`,
        location_invalid: `Emplacement invalide`,
        roles_no_company: `Titre ajouté sans organisation associée`,
        too_many_companies: `Plus de 3 organisations`,
        too_many_nickname: `Un autre prénom maximum`,
        twitter_name_invalid: `Identifiant Twitter invalide`,
        search_languages_invalid:
          `Langues de recherche invalides (utilisez en, fr, es, pt, ar, de, it, ru — max. 4, séparées par des virgules)`,
      },
      bullets: {
        first_name: 'Prénom',
        last_name: 'Nom de Famille',
        nick_name: 'Autre Prénom (optionnel)',
        alternative_first_name: 'Autre Prénom (optionnel)',
        // year_of_birth: 'Année de naissance',
        city: 'Ville de Résidence',
        province: 'Province / État',
        country: 'Pays',
        year_of_birth: 'Année de Naissance (optionnel)',
        company1:
          `Entreprise 1 (Une Entreprise à laquelle la personne est affiliée)`,
        role1: `Role 1 (Role dans l'Entreprise 1)`,
        company2:
          `Entreprise 2 (Une Entreprise à laquelle la personne est affiliée)`,
        role2: `Role 2 (Role dans l'Entreprise 2)`,
        company3:
          `Entreprise 3 (Une Entreprise à laquelle la personne est affiliée)`,
        role3: `Role 3 (Role dans l'Entreprise 3)`,
        twitter: `Nom d'utilisateur Twitter (optionnel)`,
        live_update_frequency:
          'Fréquence LiveUpdate (quotidien, hebdomadaire, mensuel ; off ou vide pour désactiver)',
        extended_report: `Recherche étendue (oui ou non)`,
        search_languages:
          `Langues de recherche (optionnel — en, fr, es, pt, ar, de, it, ru ; séparées par des virgules ; max. 4)`,
        labels: `Étiquettes`,
      },
      csv_search_languages_hint: ``,
    },
    lev_validation_form: {
      title: `Organisation à Valider`,
      fields: {
        organization_name: `Nom de l'organisation`,
        acronym: `Acronyme (optionnel)`,
        other_name: `Autre Nom (optionnel)`,
        industry: `Industrie`,
        industry_character_count: '{{count}} / {{max}}',
        industry_character_limit_reached:
          '{{count}} / {{max}} — Maximum de {{max}} caractères atteint.',
        location_empty:
          `Remplir si l'organisation est incorporée/enregistrée dans une seule juridiction, ou si vous souhaitez optimiser vos résultats de recherche.`,
      },
      error: {
        industry_must_include_alpha: `L'industrie doit inclure au moins un caractère alphabétique.`,
        industry_max_length: `L'industrie ne doit pas dépasser {{max}} caractères.`,
      },
      user_suggestions:
        `Une ou plusieurs organisations portant ce nom existent déjà. Cliquez sur l'un des noms ci-dessous pour mettre à jour leur rapport.`,
      spelling_fix:
        `Nous avons détecté sur l'internet le nom d'Organisation similaire ci-dessous. Cliquez dessus si vous souhaitez remplacer le nom que vous avez saisi.`,
    },
    validation_form: {
      spelling_fix:
        `Nous avons détecté sur l'internet le nom similaire ci-dessous. Cliquez dessus si vous souhaitez remplacer le nom que vous avez saisi.`,
      last_validated_on: `Dernière mise à jour le`,
      nothing_found: `Rien n'a été trouvé`,
      show_more_tweets: 'Afficher {{count}} résultats supplémentaires',
      submit_and_new: 'Soumettre et nouveau',
      submit_and_add_another: 'Soumettre et ajouter un autre',
      submit_more: 'Soumettre plus',
      submit_more_helper_individual:
        'Le formulaire se rouvrira après la soumission pour valider un autre individu.',
      submit_more_helper_organization:
        'Le formulaire se rouvrira après la soumission pour valider une autre organisation.',
      submit_all_new: 'Tout soumettre comme nouveau',
            submit_as_new: 'Soumettre comme nouveau',

      submit_and_close: 'Soumettre la validation',
      next: 'Suivant',
      cancel: 'Annuler',
      previous: 'Précédent',
      privacy_PRIVATE: 'Privée',
      privacy_PUBLIC: 'Partagée',
      dont_include_twitter: `Ne pas inclure Twitter`,
      year_of_birth: `Année de Naissance (optionnel)`,
      edit_twitter: {
        title: `Voulez-vous changer le nom d'utilisateur Twitter?`,
        description:
          `La modification du nom d'utilisateur supprimera tous les tweets marqués de l'autre compte.`,
      },
      title: `Individu à Valider`,
      description_editing: ``,
      user_suggestions:
        `Une ou plusieurs personnes portant ce nom existent déjà. Cliquez sur l'un des noms ci-dessous pour mettre à jour leur rapport.`,
      add_companies:
        `Organisations auxquelles la Personne est affiliée (jusqu'à 3)`,
      positions_occupied:
        `Voici les Organisations et les Titres pour chacune de celle-ci que cette Personne a occupé`,
      add_roles: `Add roles that this person occupied (recommended)`,
      twitter_username: `Nom d'utilisateur Twitter`,
      add_twitter_username: `Inclure un nom d'usager Twitter pour effectuer son analyse (optionnel)`,
      search_twitter_user: `Aucune de ces réponses? Entrez un nom d'utilisateur Twitter`,
      select_twitter_user: `Nous avons trouvé les noms d'utilisateur Twitter suivants qui pourraient appartenir à cette personne. Sélectionnez-en un pour inclure Twitter dans votre rapport.`,
      add_companies_editing:
        `Ajoutez ou supprimez des organisations (jusqu'à 3) pour modifier les résultats`,
      helper_text_company:
        `Appuyez sur Entrée pour ajouter une autre organisation`,
      helper_text_role:
        `Appuyez sur Entrée pour ajouter une autre organisation et rôle`,
      search_languages_form_description:
        `Sélectionnez jusqu'à {{max}} langues pour cette validation.`,
      no_results:
        `Effectuer votre première validation en cliquant sur le bouton en haut à gauche`,
      no_results_mobile:
        `Aucune Validation ! Exécutez votre première validation en cliquant sur le bouton en bas.`,
      tooltip:
        `Abonnement annuel en cours. Les totaux peuvent inclure des validations multiples du même individu et des validations archivées.`,
      filters: {
        max_date_error: `Doit être avant la date de fin`,
        min_date_error: `Doit être après la date de début`,
      },
      alternative_first_name_note_main: 'Autre Prénom',
      alternative_first_name_note:
        ` fournit des résultats limités. Soumettez-le dans une validation séparée en tant que Prénom si vous souhaitez étendre la recherche sur ce nom.`,
      other_name_note_main: `Autre Nom`,
      other_name_note:
        ` fournit des résultats limités. Soumettez-le dans une validation séparée en tant que Nom de l'Organisation si vous souhaitez étendre la recherche sur ce nom.`,
    },
    individual_search: {
      search_by_city: `Recherche d'individus par ville`,
    },
    usage: {
      validation_threshold_80:
        `Vous avez utilisé 80 % des validations incluses dans votre abonnement pour cette période.`,
      validation_threshold_100:
        `Vous avez utilisé toutes les validations incluses dans votre abonnement pour cette période.`,
    },
    validation_privacy: {
      public_info:
        `Cette validation sera accessible par tous les membres de votre équipe`,
      private_info_MEMBER:
        `Cette validation sera accessible par vous-même, les administrateurs de votre équipe, les administrateurs du compte et le responsable du compte`,
      private_info_LEAD:
        `Cette validation sera accessible par vous-même, les administrateurs du compte et le responsable du compte`,
      private_info_ADMIN:
        `Cette validation ne sera accessible qu'à vous-même`,
      private_info_OWNER: `Cette validation ne sera accessible qu'à vous-même`,
    },
    csv_validation_usage: {
      validations_remaining: `Vous avez {{value}} validations restantes à travers le CSV pour aujourd'hui.`,
      submit_allowance:
        `Vous pouvez soumettre {{value}} validations de plus via CSV aujourd'hui avec ce lot.`,
      zero_validations_remaining: `Vous n'avez aucune validation restante via CSV pour aujourd'hui. Veuillez soumettre vos validations de façon individuelle.`,
      limit_exceeded:
        `Vous avez atteint votre limite CSV. Vous devez retirer {{value}} validations avant de soumettre.`,
    },
  },
  labels: {
    labelsFindCreate: `Sélectionner ou créer une étiquette`,
    labelsConfirmDelete:
      `Êtes-vous sûr de vouloir supprimer l'étiquette « {{name}} » ?`,
    createLabel: `Créer une étiquette`,
    yes: `Oui`,
    no: `Non`,
    cancel: `Annuler`,
    more: `Montrer plus`,
    save: `Sauvegarder`,
    tip: `Utilisez les étiquettes pour organiser et filtrer facilement vos validations par projet.`,
    labelAdd: `Ajouter une étiquette`,
    labelAddTooltip: `Ajouter une étiquette`,
    removeLabel: `Retirer l'étiquette`,
    clearSearch: `Effacer la recherche`,
    closeLabelPicker: `Fermer le sélecteur d'étiquettes`,
  },
  pdf: {
    settings: {
      preferences: 'Préférences',
      group_by: 'Grouper par',
      risk: 'Risque',
      event: 'Événement',
      display_options: 'Options',
      show_pep_soe: 'PPE/EAE',
      show_notes: 'Notes',
      show_reviewer: 'Réviseur',
      show_article_summary: 'Résumé de l\'article',
      show_validation_labels: 'Étiquettes de validation',
      show_snippet: 'Extrait d\'article',
      show_executive_summary: 'Résumé Exécutif',
    },
    header: {
      report_title: 'Rapport de Médias en Ligne',
      powered_by: 'propulsé par',
    },
    footer: {
      report_generated_by: 'Rapport généré par',
      on: 'le',
      page: 'Page',
    },
    article: {
      id_match: 'Correspondance d\'Identité',
      no_title_available: 'Aucun titre disponible',
      no_note_content: 'Aucun contenu de note',
      unknown_user: 'Inconnu',
      user_label: 'Utilisateur',
      note_at: ' à ',
    },
  },
  report: {
    download_with_count: 'Télécharger PDF ({{count}} lien)',
    download_with_count_plural: 'Télécharger PDF ({{count}} liens)',
    downloaded: 'PDF téléchargé',
    download_with_filters: 'Télécharger PDF ({{count}} filtre appliqué)',
    download_with_filters_plural: 'Télécharger PDF ({{count}} filtres appliqués)',
  },
  popup: {
    messages: {
      validationProcessing: `Votre validation est en cours de traitement`,
      liveUpdateActivated: `Alertes liveUpdate {{frequency}} activées`,
      liveUpdateActivatedDaily: 'Alertes LiveUpdate quotidiennes activées.',
      liveUpdateActivatedWeekly: 'Alertes LiveUpdate hebdomadaires activées.',
      liveUpdateActivatedMonthly: 'Alertes LiveUpdate mensuelles activées.',
      liveUpdateDisabled: `Alertes LiveUpdate désactivées.`,
      liveUpdateUnavailable:
        `Les alertes LiveUpdate ne sont pas comprises dans votre plan.`,
      liveUpdateLimitReached:
        `La limite LiveUpdate est atteinte. Contactez-nous ou désactivez liveUpdate pour une autre entité.`,
      liveUpdateChangeFailed:
        `Impossible de mettre à jour liveUpdate (droits ou abonnement). Réessayez ou contactez votre administrateur.`,
      validationUpdating: `Votre validation est en cours de mise à jour`,
      accountRestricted:
        `Votre compte est uniquement accessible pour consulter les rapports. Veuillez nous contacter pour valider des entites.`,
      validationLimitReached:
        `Mise à niveau de votre abonnement requise. Contactez-nous`,
      subscriptionExpired:
        `Votre abonnement a expiré. Veuillez contacter Valital ou l'administrateur de votre compte`,
      subscriptionExpiredAdmin: `Votre abonnement a expiré. Contactez Valital.`,
      subscriptionExpiredNotAdmin: `Votre abonnement a expiré. Contactez l'administrateur de votre entreprise.`,
      teamValidationsExhausted:
        `Cette équipe n'a plus de validations disponibles. Contactez votre administrateur pour attribuer davantage de validations pour continuer.`,
      validationArchived: `La validation a été archivée.`,
      validationUnarchived: `La validation a été désarchivée`,
      validationDeleted: `La validation a été supprimée`,
      userInvited: `{{userName}} a été invité à rejoindre Valital`,
      validationPrivate: `La validation est privée`,
      validationShared: `La validation est partagée avec votre équipe.`,
      validationReviewed: `La validation a été revue`,
    },
  },
};
